// import React, { useEffect, useState } from "react";
// import {
//   MenuOutlined,
//   UserOutlined,
//   LogoutOutlined,
//   BellOutlined,
//   RightOutlined,
//   DownOutlined,
// } from "@ant-design/icons";
// import {
//   Button,
//   Layout,
//   Row,
//   Col,
//   Avatar,
//   Dropdown,
//   Badge,
//   Divider,
//   Modal,
//   Drawer,
//   Switch,
// } from "antd";
// import { useNavigate } from "react-router-dom";
// import { getNofications, updateNotification } from "../utils/API"; // ✅ Add your updateNotification API
// import { useNotifications } from "../Context/NotificationContext";
// import { RxUpdate } from "react-icons/rx";

// const { Header } = Layout;

// interface NavbarProps {
//   collapsed: boolean;
//   toggleSidebar: () => void;
//   disableHoverEffect: () => void;
// }

// const Navbar: React.FC<NavbarProps> = ({ toggleSidebar }) => {
//   const [modalVisible, setModalVisible] = useState(false);
//   const [selectedNotification, setSelectedNotification] = useState<any>(null);
//   const [hoveredNotificationId, setHoveredNotificationId] = useState<string | null>(null);
//   // const [notificationDropdownOpen, setNotificationDropdownOpen] = useState(false);
//   const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
//   const [showUnreadOnly, setShowUnreadOnly] = useState(false);
//   const [collapsedGroups, setCollapsedGroups] = useState<Record<string, boolean>>({});
//   const [visibleGroupCount, setVisibleGroupCount] = useState(3);

//   const navigate = useNavigate();

//   const storedUser = JSON.parse(localStorage.getItem("authData") || "{}");
//   const userId = storedUser?.user?._id || "";

//   const { notifications, setNotifications, unreadCount, fetchNotifications, markAsUnread, markAsRead } = useNotifications();

//   const hasTable = (message?: string) => {
//   if (!message) return false;
//   return message.includes("<table");
// };

//   const handleLogout = () => {
//     localStorage.removeItem("authData");
//     localStorage.removeItem("token");
//     localStorage.removeItem("favouriteFilters");
//     navigate("/login");
//   };

//   const userPhoto = storedUser?.user?.photo;
//   const avatarSrc =
//     userPhoto && typeof userPhoto === "string"
//       ? userPhoto.trim() !== ""
//         ? userPhoto.startsWith("http")
//           ? userPhoto
//           : `${process.env.REACT_APP_IMAGE_URL}/developers/${userPhoto}`
//         : process.env.PUBLIC_URL + "/download.png"
//       : process.env.PUBLIC_URL + "/download.png";

//   const handleNotificationLinkClick = (e: React.MouseEvent<HTMLDivElement>) => {
//     const target = e.target as HTMLElement;

//     if (target.tagName === "A") {
//       e.preventDefault(); // stop browser navigation

//       const href = target.getAttribute("href");
//       if (href) {
//         // Extract lead ID from href
//         // const url = new URL(href, window.location.origin);
//         // const leadId = url.searchParams.get('leadId');

//         // if (leadId) {
//         //   // Store for highlighting
//         //   sessionStorage.setItem('highlightLeadId', leadId);
//         //   sessionStorage.setItem('highlightTimestamp', Date.now().toString());
//         // }

//         navigate(href);   // React Router navigation
//         setModalVisible(false);
//         setNotificationDrawerOpen(false);
//       }
//     }
//   };

//   const handleNotificationClick = async (log: any, shouldOpenModal: any) => {
//     try {
//       if (!log.read) {
//         markAsRead(log._id);
//         await updateNotification(log._id, true);
//         setNotifications((prev) =>
//           prev.map((n) => (n._id === log._id ? { ...n, read: true } : n))
//         );
//       }

//       // ❌ Don't open modal if <= 2 lines
//       if (!shouldOpenModal) return;

//       setSelectedNotification(log);
//       setModalVisible(true);
//       // setNotificationDropdownOpen(false);
//       setNotificationDrawerOpen(false);
//     } catch (error) {
//       console.error("Error updating notification:", error);
//     }
//   };

//   const fetchLogs = async () => {
//     try {
//       fetchNotifications();
//     } catch (error) {
//       console.error("Error fetching notifications logs:", error);
//     }
//   };

//   useEffect(() => {
//     fetchLogs();
//   }, []);

//   const userMenu = (
//     <div style={{ borderRadius: "8px", border: "1px solid #f0f0f0", background: "#fff" }}>
//       <div
//         onClick={() => navigate("/profile")}
//         style={{ padding: "8px 12px", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}
//       >
//         <UserOutlined style={{ fontSize: "16px", color: "black" }} />
//         Profile
//       </div>
//       <Divider style={{ margin: "4px 0" }} />
//       <div
//         onClick={handleLogout}
//         style={{ padding: "8px 12px", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px", color: "#ff4d4f" }}
//       >
//         <LogoutOutlined style={{ fontSize: "16px", color: "#ff4d4f" }} />
//         Logout
//       </div>
//     </div>
//   );

//   //========change style of notification

//   const formatNotificationMessage = (message?: string) => {
//   if (!message) return "No message";

//   // detect if message already contains HTML tags (table, div, etc.)
//   const hasHtml = /<\/?[a-z][\s\S]*>/i.test(message);

//   // If HTML exists → return as is
//   if (hasHtml) return message;

//   // Otherwise convert line breaks for normal text notifications
//   return message.replace(/\n/g, "<br />");
// };

//   const formatTimeAgo = (date: string) => {
//     const now = new Date();
//     const created = new Date(date);
//     const diffSeconds = Math.floor(
//       (now.getTime() - created.getTime()) / 1000
//     );

//     const diffMinutes = Math.floor(diffSeconds / 60);
//     const diffHours = Math.floor(diffMinutes / 60);
//     const diffDays = Math.floor(diffHours / 24);

//     const formattedDate = created.toLocaleDateString("en-GB", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });

//     if (diffSeconds < 60) {
//       return "Just now";
//     }

//     if (diffMinutes < 60) {
//       return `${diffMinutes} min ago`;
//     }

//     if (diffHours < 24) {
//       return `${diffHours} hr ago`;
//     }

//     if (diffDays === 1) {
//       return `Yesterday • ${formattedDate}`;
//     }

//     return `${diffDays} days ago • ${formattedDate}`;
//   };

//   const notificationIconMap = {
//     task_updated: {
//       icon: "🔄",
//       bg: "#ede9fe",
//       color: "#7c3aed",
//     },
//     task_assigned: {
//       icon: "🔔",
//       bg: "#dbeafe",
//       color: "#2563eb",
//     },
//     lead_assigned: {
//       icon: "🔔",
//       bg: "#dbeafe",
//       color: "#2563eb",
//     },
//     lead_updated: {
//       icon: "🔄",
//       bg: "#ede9fe",
//       color: "#7c3aed",
//     },
//     reminder: {
//       icon: "⏰",
//       bg: "#fff7ed",
//       color: "#ea580c",
//     },
//     default: {
//       icon: "📌",
//       bg: "#e5e7eb",
//       color: "#6b7280",
//     },
//   };

//   const getNotificationStyle = (log: any) => {
//     return (
//       notificationIconMap[log.type as keyof typeof notificationIconMap] ||
//       notificationIconMap.default
//     );
//   };

//   const filteredNotifications = showUnreadOnly
//     ? notifications.filter((n) => !n.read)
//     : notifications;

//   const getNotificationGroupLabel = (dateStr: string) => {
//     const today = new Date();
//     const date = new Date(dateStr);

//     const isSameDay = (d1: Date, d2: Date) =>
//       d1.getFullYear() === d2.getFullYear() &&
//       d1.getMonth() === d2.getMonth() &&
//       d1.getDate() === d2.getDate();

//     const yesterday = new Date();
//     yesterday.setDate(today.getDate() - 1);

//     if (isSameDay(date, today)) return "Today";
//     if (isSameDay(date, yesterday)) return "Yesterday";

//     return date.toLocaleDateString("en-GB", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const groupedNotifications = filteredNotifications.reduce(
//     (groups: Record<string, typeof filteredNotifications>, log) => {
//       const label = getNotificationGroupLabel(log.createdAt);

//       if (!groups[label]) {
//         groups[label] = [];
//       }

//       groups[label].push(log);
//       return groups;
//     },
//     {}
//   );

//   const orderedGroupedNotifications = Object.entries(groupedNotifications)
//     .sort(([labelA], [labelB]) => {
//       const parseLabelDate = (label: string) => {
//         if (label === "Today") return new Date();
//         if (label === "Yesterday") {
//           const d = new Date();
//           d.setDate(d.getDate() - 1);
//           return d;
//         }
//         return new Date(label);
//       };

//       return (
//         parseLabelDate(labelB).getTime() -
//         parseLabelDate(labelA).getTime()
//       );
//     });

//   const toggleGroup = (groupLabel: string) => {
//     setCollapsedGroups((prev) => ({
//       ...prev,
//       [groupLabel]: !prev[groupLabel],
//     }));
//   };

//   const isMoreThanTwoLines = (el: HTMLDivElement | null) => {
//     if (!el) return false;
//     return el.scrollHeight > el.clientHeight;
//   };

//   const contentRefs = React.useRef<Record<string, HTMLDivElement | null>>({});

//   return (
//     <>
//       <Header className="header" style={{ padding: "0 16px" }}>
//         <Row justify="space-between" align="middle" gutter={[16, 16]}>
//           <Col xs={4} sm={3} md={2} lg={1}>
//             <Button
//               type="text"
//               icon={<MenuOutlined style={{ fontSize: "20px" }} />}
//               style={{ background: "transparent" }}
//               onClick={toggleSidebar}
//             />
//           </Col>

//           <Col>
//             <Row align="middle" gutter={16}>
//               <Col>
//                 <Badge count={unreadCount} overflowCount={99}>
//                   <BellOutlined
//                     style={{ fontSize: "20px", cursor: "pointer", color: "#444" }}
//                     onClick={() => setNotificationDrawerOpen(true)}
//                   />
//                 </Badge>
//               </Col>

//               <Col>
//                 <Dropdown overlay={userMenu} trigger={["click"]} placement="bottomRight">
//                   <Avatar
//                     style={{
//                       cursor: "pointer",
//                       backgroundColor: "#d9d9d9",
//                       width: "40px",
//                       height: "40px",
//                       marginBottom: "16px",
//                     }}
//                     icon={!userPhoto || typeof userPhoto !== "string" ? <UserOutlined /> : undefined}
//                     src={avatarSrc}
//                     className="border-2"
//                   />
//                 </Dropdown>
//               </Col>
//             </Row>
//           </Col>
//         </Row>
//       </Header>

//       <Drawer
//         title={null}
//         placement="right"
//         width={420}
//         open={notificationDrawerOpen}
//         onClose={() => setNotificationDrawerOpen(false)}
//         bodyStyle={{ padding: 0, background: "#f9fafb" }}
//       >
//         {/* ===== HEADER ===== */}
//         <div
//           style={{
//             position: "sticky",
//             top: 0,
//             zIndex: 10,
//             background: "#ffffff",
//             padding: "16px 20px",
//             borderBottom: "1px solid #e5e7eb",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ fontSize: 18, fontWeight: 600, color: "#111827" }}>
//             Notifications
//           </div>

//           {/* SWITCH */}
//           <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//             <span
//               style={{
//                 fontSize: 12,
//                 color: showUnreadOnly ? "#2563eb" : "#6b7280",
//                 fontWeight: 500,
//               }}
//             >
//               Show only Unread
//             </span>

//             <Switch
//               size="small"
//               checked={showUnreadOnly}
//               onChange={(checked) => setShowUnreadOnly(checked)}
//             />
//           </div>
//         </div>

//         {/* ===== CONTENT ===== */}
//         <div>
//           {Object.keys(groupedNotifications).length > 0 ? (
//             orderedGroupedNotifications.slice(0, visibleGroupCount).map(([groupLabel, logs]) => (
//               <div key={groupLabel}>
//                 {/* GROUP HEADER */}
//                 <div
//                   onClick={() => toggleGroup(groupLabel)}
//                   style={{
//                     padding: "8px 20px",
//                     fontSize: 12,
//                     fontWeight: 600,
//                     color: "#6b7280",
//                     background: "#f3f4f6",
//                     // borderBottom: "1px solid #e5e7eb",
//                     textTransform: "uppercase",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     cursor: "pointer",
//                   }}
//                 >
//                   <span>{groupLabel}</span>

//                   <RightOutlined
//                     className={`text-xs transition-transform duration-300 ${collapsedGroups[groupLabel] ? "rotate-0" : "rotate-90"
//                       }`}
//                   />
//                 </div>

//                 {/* GROUP ITEMS */}
//                 <div
//                   className={`overflow-hidden transition-all ease-in-out
//                       ${collapsedGroups[groupLabel]
//                       ? "max-h-0 opacity-0 scale-y-95"
//                       : "opacity-100 scale-y-100"}
//                       duration-500`}
//                 >
//                   {logs.map((log) => {
//                     const iconStyle = getNotificationStyle(log);

//                     return (
//                       <div
//                         key={log._id}
//                         onClick={() => {
//                           const el = contentRefs.current[log._id];
//                           const shouldOpenModal =
//   isMoreThanTwoLines(el) || hasTable(log.message);

// handleNotificationClick(log, shouldOpenModal);
//                         }}
//                         onMouseEnter={() => setHoveredNotificationId(log._id)}
//                         onMouseLeave={() => setHoveredNotificationId(null)}
//                         style={{
//                           display: "flex",
//                           gap: 12,
//                           padding: "14px 20px",
//                           cursor: "pointer",
//                           backgroundColor: log.read ? "#ffffff" : "#eef6ff",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {/* ICON */}
//                         <div
//                           style={{
//                             width: 38,
//                             height: 38,
//                             borderRadius: "50%",
//                             background: iconStyle.bg,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             fontSize: 16,
//                             color: iconStyle.color,
//                             flexShrink: 0,
//                           }}
//                         >
//                           {iconStyle.icon}
//                         </div>

//                         {/* CONTENT */}
//                         <div style={{ flex: 1 }}>
//                           <div
//                             ref={(el) => {
//                               contentRefs.current[log._id] = el;
//                             }}
//                             style={{
//                               fontSize: 14,
//                               fontWeight: log.read ? 400 : 600,
//                               color: "#111827",
//                               lineHeight: "1.45em",
//                               display: "-webkit-box",
//                               WebkitBoxOrient: "vertical",
//                               WebkitLineClamp: 2,
//                               overflow: "hidden",
//                             }}
//                             dangerouslySetInnerHTML={{
//                               __html: log.message || "No message",
//                             }}
//                           />

//                           <div
//                             style={{
//                               marginTop: 6,
//                               fontSize: 12,
//                               color: "#6b7280",
//                             }}
//                           >
//                             {formatTimeAgo(log.createdAt)}
//                           </div>
//                         </div>

//                         {/* ACTION */}
//                         <div
//                           onClick={(e) => e.stopPropagation()}
//                           style={{
//                             width: 70,
//                             display: "flex",
//                             justifyContent: "flex-end",
//                             alignItems: "center",
//                           }}
//                         >
//                           {!log.read && (
//                             <span
//                               style={{
//                                 width: 8,
//                                 height: 8,
//                                 borderRadius: "50%",
//                                 backgroundColor: "#2563eb",
//                               }}
//                             />
//                           )}

//                           {log.read && hoveredNotificationId === log._id && (
//                             <button
//                               className="unread-btn"
//                               onClick={async (e) => {
//                                 e.stopPropagation();
//                                 try {
//                                   markAsUnread(log._id);
//                                   await updateNotification(log._id, false);
//                                   // Use markAsUnread from context instead
//                                 } catch (error) {
//                                   console.error("Error marking as unread:", error);
//                                 }
//                               }}
//                             >
//                               Unread
//                             </button>
//                           )}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div
//               style={{
//                 padding: "48px",
//                 textAlign: "center",
//                 color: "#9ca3af",
//                 fontSize: 14,
//               }}
//             >
//               No notifications
//             </div>
//           )}
//         </div>
//         {visibleGroupCount < orderedGroupedNotifications.length && (
//           <div className="flex justify-center py-4">
//             <button
//               onClick={() => setVisibleGroupCount((prev) => prev + 3)}
//               className="
//                 w-full
//                 flex
//                 items-center
//                 justify-center
//                 gap-1
//                 py-2
//                 px-4
//                 border
//                 border-gray-200
//                 rounded-md
//                 text-blue-600
//                 font-medium
//                 text-sm
//                 hover:bg-gray-50
//                 hover:border-gray-300
//                 transition
//                 duration-150
//               "
//             >
//               More Notifications
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-4 w-4"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//                 strokeWidth={2}
//               >
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
//               </svg>
//             </button>
//           </div>
//         )}
//       </Drawer >

//       {/* Notification Modal */}
//       <Modal
//         width={600}
//         height={400}
//         open={modalVisible}
//         onCancel={() => setModalVisible(false)}
//         footer={null}
//         destroyOnClose
//         className="custom-modal-one"
//         style={{ bottom: 20, top: 20 }}
//         title={
//           <div style={{
//             marginLeft: "11px",
//             width: "100%",
//             paddingRight: 20,
//             borderBottom: "1px solid #e8e8e8",  // subtle divider color
//             paddingBottom: 8,
//             paddingTop: 8,
//             fontWeight: "bold",
//             fontSize: "16px",
//           }}>
//             Notification
//           </div>
//         }
//         bodyStyle={{ overflowY: "auto", maxHeight: "60vh", fontFamily: "inter, sans-serif" }}
//       >
//         <div className="elements" onClick={handleNotificationLinkClick}>
//   <div
//     style={{ padding: "1vw", lineHeight: "1.6" }}
//     dangerouslySetInnerHTML={{
//       __html: selectedNotification?.message?selectedNotification?.message.replace(/\n/g, "<br />") : "No message",
//     }}
//   />
// </div>
//         <div className="footer-modals" />
//       </Modal>
//     </>
//   );
// };

// export default Navbar;

import React, { useEffect, useState } from "react";
import {
  MenuOutlined,
  UserOutlined,
  LogoutOutlined,
  BellOutlined,
  BellFilled,
  RightOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { PiBellRingingThin } from "react-icons/pi";
import {
  Button,
  Layout,
  Row,
  Col,
  Avatar,
  Dropdown,
  Badge,
  Divider,
  Modal,
  Drawer,
  Switch,
  Tooltip,
  message,
  Spin,
} from "antd";
import { useNavigate } from "react-router-dom";
// import { getNofications, updateNotification, getAllRawData, getTaskByID } from "../utils/API";
import {
  getNofications,
  updateNotification,
  getLeadStatus,
  getTaskByID,
} from "../utils/API";
import { useNotifications } from "../Context/NotificationContext";
// import { RxUpdate } from "react-icons/rx";

// import dayjs from "dayjs";

const { Header } = Layout;

interface NavbarProps {
  collapsed: boolean;
  toggleSidebar: () => void;
  disableHoverEffect: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ toggleSidebar }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState<any>(null);
  const [hoveredNotificationId, setHoveredNotificationId] = useState<
    string | null
  >(null);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);
  const [collapsedGroups, setCollapsedGroups] = useState<
    Record<string, boolean>
  >({});
  const [visibleGroupCount, setVisibleGroupCount] = useState(3);
  const [isUpdating, setIsUpdating] = useState(false);
  const [followUpPage, setFollowUpPage] = useState(1);
  const FOLLOW_UP_PAGE_SIZE = 7;
  // const [liveLeadData, setLiveLeadData] = useState<any[]>([]);
  // const [loadingLiveData, setLoadingLiveData] = useState(false);
  // const [liveTaskData, setLiveTaskData] = useState<any[]>([]);
  // const [loadingLiveTaskData, setLoadingLiveTaskData] = useState(false);
  const [leadStatuses, setLeadStatuses] = useState<any[]>([]);
  const [notificationTaskDetails, setNotificationTaskDetails] =
    useState<any>(null);

  const navigate = useNavigate();

  const storedUser = JSON.parse(localStorage.getItem("authData") || "{}");
  const userId = storedUser?.user?._id || "";
  const isDeveloper =
    storedUser?.roleId?.roleId === 2 ||
    storedUser?.roleId?.name?.toLowerCase() === "developer";

  const {
    notifications,
    setNotifications,
    unreadCount,
    fetchNotifications,
    markAsUnread,
    markAsRead,
  } = useNotifications();

  const hasTable = (message?: string) => {
    if (!message) return false;
    return (
      message.includes("<table") ||
      message.includes("<tr") ||
      message.includes("<td") ||
      message.includes("/rawdata?lead=") ||
      message.includes("/tasks?id=")
    );
  };

  const handleLogout = () => {
    localStorage.removeItem("authData");
    localStorage.removeItem("token");
    localStorage.removeItem("favouriteFilters");
    navigate("/login");
  };

  const userPhoto = storedUser?.user?.photo;
  const avatarSrc =
    userPhoto && typeof userPhoto === "string"
      ? userPhoto.trim() !== ""
        ? userPhoto.startsWith("http")
          ? userPhoto
          : `${process.env.REACT_APP_IMAGE_URL}/developers/${userPhoto}`
        : process.env.PUBLIC_URL + "/download.png"
      : process.env.PUBLIC_URL + "/download.png";

  // Extract all individual lead IDs from notification message href attributes
  // const extractLeadIdsFromMessage = (msg?: string): string[] => {
  //   if (!msg) return [];
  //   const matches = Array.from(msg.matchAll(/\/rawdata\?lead=([a-f0-9,]+)/gi));
  //   const ids = new Set<string>();
  //   matches.forEach(m => m[1].split(",").forEach(id => ids.add(id.trim())));
  //   return Array.from(ids);
  // };

  // Fetch live lead data when modal opens for table notifications
  // const fetchLiveLeadData = async (msg?: string) => {
  //   const ids = extractLeadIdsFromMessage(msg);
  //   if (!ids.length) return;
  //   setLoadingLiveData(true);
  //   try {
  //     const res = await getAllRawData({ ids });
  //     const data = Array.isArray(res.data) ? res.data : [res.data];
  //     setLiveLeadData(data);
  //   } catch (err) {
  //     console.error("Failed to fetch live lead data:", err);
  //     setLiveLeadData([]);
  //   } finally {
  //     setLoadingLiveData(false);
  //   }
  // };

  // const extractTaskIdFromMessage = (msg?: string): string | null => {
  //   if (!msg) return null;
  //   const match = msg.match(/\/tasks\?id=([a-f0-9]+)/i);
  //   return match ? match[1] : null;
  // };

  // const fetchLiveTaskData = async (msg?: string) => {
  //   const id = extractTaskIdFromMessage(msg);
  //   if (!id) return;
  //   setLoadingLiveTaskData(true);
  //   try {
  //     const res = await getTaskByID(id);
  //     setLiveTaskData(res ? [res] : []);
  //   } catch (err) {
  //     console.error("Failed to fetch live task data:", err);
  //     setLiveTaskData([]);
  //   } finally {
  //     setLoadingLiveTaskData(false);
  //   }
  // };

  // const extractLeadUrl = (msg?: string): string | null => {
  //   if (!msg) return null;
  //   const match = msg.match(/href="([^"]+)"/);
  //   return match ? match[1] : null;
  // };

  // For table notifications: extract the last href (View All link with all lead IDs)
  // const extractAllLeadsUrl = (msg?: string): string | null => {
  //   if (!msg) return null;
  //   const matches = Array.from(msg.matchAll(/href="([^"]+)"/g));
  //   if (!matches.length) return null;
  //   return matches[matches.length - 1][1];
  // };

  // const extractTaskUrl = (msg?: string): string | null => {
  //   const taskId = extractTaskIdFromMessage(msg);
  //   return taskId ? `/tasks?id=${taskId}` : null;
  // };

  const handleNotificationLinkClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;
    if (target.tagName === "A") {
      e.preventDefault();
      const href = target.getAttribute("href");
      if (href) {
        navigate(href);
        setModalVisible(false);
        setNotificationDrawerOpen(false);
      }
    }
  };

  const handleNotificationClick = async (log: any) => {
    try {
      if (!log.read) {
        markAsRead(log._id);
        await updateNotification(log._id, true);
        setNotifications((prev) =>
          prev.map((n) => (n._id === log._id ? { ...n, read: true } : n)),
        );
      }
      setSelectedNotification(log);
      setNotificationTaskDetails(null);
      setFollowUpPage(1);
      setModalVisible(true);
      setNotificationDrawerOpen(false);

      const normalizedType = String(log.type || "")
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
      const normalizedTitle = String(log.title || "")
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
      const taskIdFromMessage =
        String(log.message || "").match(/\/tasks\?id=([a-f0-9]{24})/i)?.[1] ||
        null;
      const taskMongoId = log.details?.entityMongoId || taskIdFromMessage;

      if (
        taskMongoId &&
        (normalizedType.includes("task") || normalizedTitle.includes("task"))
      ) {
        try {
          const task = await getTaskByID(taskMongoId);
          setNotificationTaskDetails(task);
        } catch (err) {
          console.error("Failed to fetch notification task details:", err);
        }
      }
    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };

  // ============ SINGLE BUTTON HANDLER ============
  const handleMarkAll = async () => {
    const unreadNotifications = notifications.filter((n) => !n.read);
    const readNotifications = notifications.filter((n) => n.read);

    // If there are unread notifications, mark all as read
    if (unreadNotifications.length > 0) {
      if (unreadNotifications.length === 0) {
        message.info("No unread notifications");
        return;
      }

      setIsUpdating(true);
      try {
        await Promise.all(
          unreadNotifications.map((notification) =>
            updateNotification(notification._id, true),
          ),
        );

        setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));

        message.success(
          `Marked ${unreadNotifications.length} notifications as read`,
        );
      } catch (error) {
        console.error("Error marking all as read:", error);
        message.error("Failed to mark all as read");
      } finally {
        setIsUpdating(false);
      }
    }
    // If all notifications are read, mark all as unread
    else if (readNotifications.length > 0) {
      if (readNotifications.length === 0) {
        message.info("No read notifications");
        return;
      }

      setIsUpdating(true);
      try {
        await Promise.all(
          readNotifications.map((notification) =>
            updateNotification(notification._id, false),
          ),
        );

        setNotifications((prev) => prev.map((n) => ({ ...n, read: false })));

        message.success(
          `Marked ${readNotifications.length} notifications as unread`,
        );
      } catch (error) {
        console.error("Error marking all as unread:", error);
        message.error("Failed to mark all as unread");
      } finally {
        setIsUpdating(false);
      }
    }
  };

  // Determine button state based on notifications
  const getButtonConfig = () => {
    const hasUnread = notifications.some((n) => !n.read);
    const hasRead = notifications.some((n) => n.read);

    // If there are unread notifications, show "Read All"
    if (hasUnread) {
      return {
        text: "Read All",
        icon: <CheckOutlined />,
        color: "#22c55e",
        tooltip: "Mark all as read",
        shadow: "0 2px 4px rgba(34, 197, 94, 0.2)",
        hoverColor: "#16a34a",
      };
    }
    // If all notifications are read, show "Unread All"
    else if (hasRead) {
      return {
        text: "Unread All",
        icon: <CloseOutlined />,
        color: "#ef4444",
        tooltip: "Mark all as unread",
        shadow: "0 2px 4px rgba(239, 68, 68, 0.2)",
        hoverColor: "#dc2626",
      };
    }
    // If no notifications, return null (button won't show)
    return null;
  };

  const fetchLogs = async () => {
    try {
      fetchNotifications();
    } catch (error) {
      console.error("Error fetching notifications logs:", error);
    }
  };

  useEffect(() => {
    fetchLogs();

    if (isDeveloper) {
      setLeadStatuses([]);
      return;
    }

    getLeadStatus()
      .then((res) => setLeadStatuses(res.data || []))
      .catch((err) => console.error("Failed to fetch lead statuses", err));
  }, []);

  const userMenu = (
    <div
      style={{
        borderRadius: "8px",
        border: "1px solid #f0f0f0",
        background: "#fff",
      }}
    >
      <div
        onClick={() => navigate("/profile")}
        style={{
          padding: "8px 12px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <UserOutlined style={{ fontSize: "16px", color: "black" }} />
        Profile
      </div>
      <Divider style={{ margin: "4px 0" }} />
      <div
        onClick={handleLogout}
        style={{
          padding: "8px 12px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: "#ff4d4f",
        }}
      >
        <LogoutOutlined style={{ fontSize: "16px", color: "#ff4d4f" }} />
        Logout
      </div>
    </div>
  );

  // const stripHtml = (html?: string) => {
  //   if (!html) return "";
  //   return html
  //     .replace(/<[^>]*>?/gm, "")
  //     .replace(/&nbsp;/g, " ")
  //     .replace(/&amp;/g, "&")
  //     .replace(/&lt;/g, "<")
  //     .replace(/&gt;/g, ">")
  //     .trim();
  // };

  // const cleanValue = (value: any): string => {
  //   if (value === undefined || value === null || value === "") return "N/A";
  //   if (Array.isArray(value)) {
  //     const list = value.map((item) => cleanValue(item)).filter((item) => item !== "N/A").join(", ");
  //     return list || "N/A";
  //   }
  //   if (typeof value === "object") {
  //     const fullName = [value.firstName, value.lastName].filter(Boolean).join(" ").trim();
  //     return cleanValue(
  //       fullName ||
  //       value.name ||
  //       value.title ||
  //       value.taskName ||
  //       value.contactName ||
  //       value.username ||
  //       value.email ||
  //       value.label ||
  //       value.slug ||
  //       value.status ||
  //       value.value ||
  //       value._id
  //     );
  //   }
  //   return stripHtml(String(value)).replace(/^["']|["']$/g, "").trim() || "N/A";
  // };

  // const formatChangedProperty = (field: any): string => {
  //   const value = cleanValue(field)
  //     .replace(/^lead\s+/i, "")
  //     .replace(/^task\s+/i, "")
  //     .replace(/^(changed|updated|modified)\s+/i, "")
  //     .replace(/\s*(changed|updated|modified)$/i, "")
  //     .trim();
  //   const key = value.toLowerCase().replace(/[^a-z0-9]/g, "");
  //   if (key.includes("priority")) return "Priority";
  //   if (key.includes("status") || key.includes("leadstatus")) return "Status";
  //   if (key.includes("title") || key.includes("taskname")) return "Title";
  //   if (key.includes("company")) return "Company";
  //   if (key.includes("contact")) return "Contact";
  //   if (key.includes("email")) return "Email";
  //   if (key.includes("phone")) return "Phone";
  //   if (key.includes("owner")) return "Owner";
  //   if (key.includes("assignee") || key.includes("assignees")) return "Assignee";
  //   if (key.includes("reporter")) return "Reporter";
  //   if (key.includes("deadline")) return "Deadline";
  //   if (key.includes("startdate")) return "Start Date";
  //   if (key.includes("enddate")) return "End Date";
  //   if (key.includes("followup")) return "Follow-Up Date";
  //   if (key.includes("value") || key.includes("amount")) return "Value";
  //   if (key.includes("description") || key.includes("desc")) return "Description";
  //   return value || "Updated";
  // };

  // const parseUpdateChanges = (message?: string, notification?: any): any[] => {
  //   const changes: any[] = [];
  //   const seen = new Set<string>();
  //   const addChange = (field: any, previous: any, current: any, updatedBy: any, extra: any = {}) => {
  //     if (field === undefined || previous === undefined || current === undefined) return;
  //     const row = {
  //       field: cleanValue(field),
  //       previous: cleanValue(previous),
  //       current: cleanValue(current),
  //       updatedBy: cleanValue(updatedBy || notification?.updatedBy || "N/A"),
  //       entityId: cleanValue(extra.entityId),
  //       entityTitle: cleanValue(extra.entityTitle),
  //     };
  //     if (row.previous === "N/A" && row.current === "N/A") return;
  //     const key = `${row.entityId}|${row.field}|${row.previous}|${row.current}`;
  //     if (seen.has(key)) return;
  //     seen.add(key);
  //     changes.push(row);
  //   };

  //   const firstValue = (source: any, keys: string[]) => {
  //     if (!source || typeof source !== "object") return undefined;
  //     for (const key of keys) {
  //       if (source[key] !== undefined && source[key] !== null) return source[key];
  //     }
  //     return undefined;
  //   };

  //   const getActor = (source?: any) =>
  //     firstValue(source, ["updatedBy", "changedBy", "modifiedBy", "userName", "user", "actor"]) ||
  //     notification?.updatedBy;

  //   const getEntityExtra = (source?: any) => ({
  //     entityId: firstValue(source, ["id", "leadId", "taskId", "leadCode", "taskCode"]),
  //     entityTitle: firstValue(source, ["title", "taskName", "leadTitle", "name", "contactName"]),
  //   });

  //   const addObjectDiffs = (previousObj: any, currentObj: any, updatedBy: any, extra: any = {}) => {
  //     if (
  //       !previousObj ||
  //       !currentObj ||
  //       typeof previousObj !== "object" ||
  //       typeof currentObj !== "object" ||
  //       Array.isArray(previousObj) ||
  //       Array.isArray(currentObj)
  //     ) {
  //       return;
  //     }

  //     const skipFields = new Set([
  //       "_id",
  //       "id",
  //       "__v",
  //       "createdAt",
  //       "updatedAt",
  //       "createdBy",
  //       "updatedBy",
  //       "isDeleted",
  //     ]);
  //     const fields = new Set([...Object.keys(previousObj), ...Object.keys(currentObj)]);

  //     fields.forEach((field) => {
  //       if (skipFields.has(field)) return;
  //       const previousValue = previousObj[field];
  //       const currentValue = currentObj[field];
  //       if (cleanValue(previousValue) === cleanValue(currentValue)) return;
  //       addChange(field, previousValue, currentValue, updatedBy, extra);
  //     });
  //   };

  //   const metadataChanges =
  //     notification?.changes ||
  //     notification?.changedFields ||
  //     notification?.updatedFields ||
  //     notification?.changeLog ||
  //     notification?.updates ||
  //     notification?.data?.changes ||
  //     notification?.data?.changedFields ||
  //     notification?.data?.updatedFields ||
  //     notification?.data?.changeLog ||
  //     notification?.data?.updates ||
  //     notification?.metadata?.changes ||
  //     notification?.metadata?.changedFields ||
  //     notification?.metadata?.updatedFields ||
  //     notification?.metadata?.changeLog ||
  //     notification?.metadata?.updates ||
  //     notification?.payload?.changes ||
  //     notification?.payload?.changedFields ||
  //     notification?.payload?.updatedFields ||
  //     notification?.payload?.changeLog ||
  //     notification?.payload?.updates;

  //   if (Array.isArray(metadataChanges)) {
  //     metadataChanges.forEach((change: any) => {
  //       addChange(
  //         change.field || change.key || change.property || change.changedProperty || change.fieldName || change.name,
  //         change.previous ?? change.old ?? change.oldValue ?? change.old_value ?? change.previousValue ?? change.previous_value ?? change.beforeValue ?? change.before_value ?? change.from ?? change.before,
  //         change.current ?? change.new ?? change.newValue ?? change.new_value ?? change.currentValue ?? change.current_value ?? change.afterValue ?? change.after_value ?? change.to ?? change.after,
  //         change.updatedBy,
  //         {
  //           entityId: change.id || change.leadId || change.taskId,
  //           entityTitle: change.title || change.taskName || change.leadTitle || change.name,
  //         }
  //       );
  //     });
  //   } else if (metadataChanges && typeof metadataChanges === "object") {
  //     addChange(
  //       firstValue(metadataChanges, ["field", "key", "property", "changedProperty", "changedField", "fieldName", "name"]),
  //       firstValue(metadataChanges, ["previous", "old", "oldValue", "old_value", "previousValue", "previous_value", "beforeValue", "before_value", "from", "before"]),
  //       firstValue(metadataChanges, ["current", "new", "newValue", "new_value", "currentValue", "current_value", "afterValue", "after_value", "to", "after"]),
  //       getActor(metadataChanges),
  //       getEntityExtra(metadataChanges)
  //     );

  //     addObjectDiffs(
  //       firstValue(metadataChanges, ["previousData", "oldData", "oldValues", "beforeData", "before", "previous", "old"]),
  //       firstValue(metadataChanges, ["currentData", "newData", "newValues", "afterData", "after", "current", "new", "updated"]),
  //       getActor(metadataChanges),
  //       getEntityExtra(metadataChanges)
  //     );

  //     Object.entries(metadataChanges).forEach(([field, value]: any) => {
  //       if (Array.isArray(value) && value.length >= 2) {
  //         addChange(field, value[0], value[1], notification?.updatedBy);
  //         return;
  //       }

  //       addChange(
  //         field,
  //         value?.previous ?? value?.old ?? value?.oldValue ?? value?.old_value ?? value?.previousValue ?? value?.previous_value ?? value?.beforeValue ?? value?.before_value ?? value?.from ?? value?.before,
  //         value?.current ?? value?.new ?? value?.newValue ?? value?.new_value ?? value?.currentValue ?? value?.current_value ?? value?.afterValue ?? value?.after_value ?? value?.to ?? value?.after,
  //         value?.updatedBy,
  //         {
  //           entityId: value?.id || value?.leadId || value?.taskId,
  //           entityTitle: value?.title || value?.taskName || value?.leadTitle || value?.name,
  //         }
  //       );
  //     });
  //   }

  //   [
  //     notification,
  //     notification?.data,
  //     notification?.details,
  //     notification?.metadata,
  //     notification?.payload,
  //     notification?.extra,
  //   ].forEach((container) => {
  //     if (!container || typeof container !== "object") return;

  //     addObjectDiffs(
  //       firstValue(container, [
  //         "previousData",
  //         "oldData",
  //         "oldValues",
  //         "beforeData",
  //         "before",
  //         "previous",
  //         "old",
  //         "prev",
  //         "original",
  //         "previousLead",
  //         "oldLead",
  //         "previousTask",
  //         "oldTask",
  //       ]),
  //       firstValue(container, [
  //         "currentData",
  //         "newData",
  //         "newValues",
  //         "afterData",
  //         "after",
  //         "current",
  //         "new",
  //         "updated",
  //         "updatedLead",
  //         "newLead",
  //         "updatedTask",
  //         "newTask",
  //       ]),
  //       getActor(container),
  //       getEntityExtra(container)
  //     );

  //     addChange(
  //       firstValue(container, ["field", "key", "property", "changedProperty", "changedField", "fieldName"]),
  //       firstValue(container, ["previousValue", "previous_value", "oldValue", "old_value", "beforeValue", "before_value", "from", "before", "previous", "old"]),
  //       firstValue(container, ["currentValue", "current_value", "newValue", "new_value", "afterValue", "after_value", "to", "after", "current", "new"]),
  //       getActor(container),
  //       getEntityExtra(container)
  //     );
  //   });

  //   if (message) {
  //     Array.from(message.matchAll(/<table[\s\S]*?<\/table>/gi)).forEach((tableMatch) => {
  //       const rows = Array.from(tableMatch[0].matchAll(/<tr[\s\S]*?<\/tr>/gi))
  //         .map((rowMatch) =>
  //           Array.from(rowMatch[0].matchAll(/<(th|td)[^>]*>([\s\S]*?)<\/\1>/gi))
  //             .map((cellMatch) => stripHtml(cellMatch[2]).replace(/\s+/g, " ").trim())
  //         )
  //         .filter((row) => row.length > 0);
  //       if (rows.length < 2) return;

  //       const headers = rows[0].map((header) => header.toLowerCase().replace(/[^a-z0-9]/g, ""));
  //       const findColumn = (keys: string[]) => headers.findIndex((header) => keys.includes(header));
  //       const fieldIndex = findColumn(["changedproperty", "property", "field", "fieldname", "change"]);
  //       const previousIndex = findColumn(["previous", "old", "oldvalue", "from", "before"]);
  //       const currentIndex = findColumn(["new", "current", "newvalue", "to", "after"]);
  //       if (fieldIndex < 0 || previousIndex < 0 || currentIndex < 0) return;

  //       const idIndex = findColumn(["id", "leadid", "taskid", "lead"]);
  //       const titleIndex = findColumn(["title", "task", "taskname", "name"]);
  //       const updatedByIndex = findColumn(["updatedby", "changedby", "modifiedby", "user"]);

  //       rows.slice(1).forEach((row) => {
  //         addChange(
  //           row[fieldIndex],
  //           row[previousIndex],
  //           row[currentIndex],
  //           updatedByIndex >= 0 ? row[updatedByIndex] : undefined,
  //           {
  //             entityId: idIndex >= 0 ? row[idIndex] : undefined,
  //             entityTitle: titleIndex >= 0 ? row[titleIndex] : undefined,
  //           }
  //         );
  //       });
  //     });

  //     const cleanMessage = stripHtml(message.replace(/<a[^>]*>[\s\S]*?<\/a>/gi, ""))
  //       .replace(/[\u2192\u21D2\u279C\u2794\u279D]/g, " -> ")
  //       .replace(/&rarr;|&#8594;|→|⇒|➜|➔|â†’|â‡’|âžœ|âž”/gi, " -> ")
  //       .replace(/\s+/g, " ")
  //       .trim();
  //     const updatedBy = cleanMessage.match(/updated\s*by\s*:?\s*(.*?)(?=\s*(?:\||changes?\s*:|$))/i)?.[1];
  //     const changesText = cleanMessage.match(/changes?\s*:/i)
  //       ? cleanMessage.slice((cleanMessage.match(/changes?\s*:/i)?.index || 0) + (cleanMessage.match(/changes?\s*:/i)?.[0].length || 0))
  //       : cleanMessage.replace(/updated\s*by\s*:?\s*[^|]*(?:\||$)/i, "");

  //     changesText.split(/\s*\|\s*|\s*;\s*/).map((part) => part.trim()).filter(Boolean).forEach((part) => {
  //       const directMatch = part.match(/^([^:]+):\s*\(?\s*(.+?)\s*(?:->|=>|\bto\b)\s*(.+?)\s*\)?$/i);
  //       const fromToMatch = part.match(/^(.+?)\s+(?:(?:changed|updated|modified)\s+)?from\s+(.+?)\s+to\s+(.+)$/i);
  //       const match = directMatch || fromToMatch;
  //       if (match) addChange(match[1], match[2], match[3], updatedBy);
  //     });

  //     const normalizedUpdateMessage = stripHtml(message.replace(/<a[^>]*>[\s\S]*?<\/a>/gi, ""))
  //       .replace(/[\u2192\u21D2\u279C\u2794\u279D]/g, " -> ")
  //       .replace(/&rarr;|&#8594;|&#x2192;|→|⇒|➜|➔|➝|â†’|â‡’|âžœ|âž”|Ã¢â€ â€™|Ã¢â€¡â€™|Ã¢Å¾Å“|Ã¢Å¾â€/gi, " -> ")
  //       .replace(/\s+/g, " ")
  //       .trim();
  //     const normalizedUpdatedBy =
  //       normalizedUpdateMessage.match(/updated\s*by\s*:?\s*(.*?)(?=\s*(?:\||changes?\s*:|$))/i)?.[1] ||
  //       normalizedUpdateMessage.match(/updatedby\s*:?\s*(.*?)(?=\s*(?:\||changes?\s*:|$))/i)?.[1];
  //     const normalizedChangesMatch = normalizedUpdateMessage.match(/changes?\s*:\s*(.*)$/i);
  //     const normalizedChangesText = normalizedChangesMatch?.[1] || normalizedUpdateMessage;

  //     normalizedChangesText
  //       .split(/\s*\|\s*|\s*;\s*/)
  //       .map((part) => part.replace(/^changes?\s*:\s*/i, "").trim())
  //       .filter(Boolean)
  //       .forEach((part) => {
  //         const match =
  //           part.match(/^([^:]+):\s*\(?\s*(.+?)\s*(?:->|=>|\bto\b)\s*(.+?)\s*\)?$/i) ||
  //           part.match(/^(.+?)\s+(?:(?:changed|updated|modified)\s+)?from\s+(.+?)\s+to\s+(.+)$/i);

  //         if (match) {
  //           addChange(match[1], match[2], match[3], normalizedUpdatedBy);
  //           return;
  //         }

  //         const arrowOnlyMatch = part.match(/^(.+?)\s*(?:->|=>)\s*(.+)$/i);
  //         if (arrowOnlyMatch && changes.length === 0) {
  //           addChange("Status", arrowOnlyMatch[1], arrowOnlyMatch[2], normalizedUpdatedBy);
  //         }
  //       });

  //     const priorityUpdateMessage = normalizedUpdateMessage
  //       .replace(/[\u2192\u21D2\u279C\u2794\u279D]/g, " -> ")
  //       .replace(/&rarr;|&#8594;|&#x2192;/gi, " -> ");

  //     [
  //       /(?:^|\||;)\s*(?:lead\s+)?priority\s*(?:changed|updated|modified)?\s*(?:from)?\s*:?\s*(.+?)\s*(?:->|=>|\bto\b)\s*(.+?)(?=\s*(?:\||;|$))/gi,
  //       /(?:^|\||;)\s*(?:changed|updated|modified)\s+(?:lead\s+)?priority\s+from\s+(.+?)\s+to\s+(.+?)(?=\s*(?:\||;|$))/gi,
  //       /(?:^|\||;)\s*(?:lead\s+)?priority\s+(?:was\s+)?(?:changed|updated|modified)\s+from\s+(.+?)\s+to\s+(.+?)(?=\s*(?:\||;|$))/gi,
  //     ].forEach((pattern) => {
  //       Array.from(priorityUpdateMessage.matchAll(pattern)).forEach((match) => {
  //         addChange("Priority", match[1], match[2], normalizedUpdatedBy);
  //       });
  //     });
  //   }

  //   return changes;
  // };

  const getStatusColor = (value: any) => {
    const status = String(value ?? "").toLowerCase();
    if (status.includes("completed") || status.includes("proposal"))
      return "#10b981";
    if (status.includes("follow")) return "#06b6d4";
    if (status.includes("pending") || status.includes("medium"))
      return "#f59e0b";
    if (
      status.includes("cancel") ||
      status.includes("high") ||
      status.includes("overdue")
    )
      return "#ef4444";
    if (status.includes("progress")) return "#3b82f6";
    return "#6b7280";
  };

  const formatNotificationMessage = (message?: string) => {
    if (!message) return "No message";

    const hasHtml = /<\/?[a-z][\s\S]*>/i.test(message);

    if (hasHtml) return message;

    return message.replace(/\n/g, "<br />");
  };

  const getDrawerMessagePreview = (message?: string) => {
    if (!message) return "No message";

    // 1. Remove the table and its contents completely
    let previewText = message.replace(/<table[^>]*>[\s\S]*?<\/table>/gi, "");

    // 2. Remove the "View Follow-ups" link/text completely (catches both HTML and plain text)
    previewText = previewText.replace(
      /<a[^>]*>.*?View Follow-ups.*?<\/a>/gi,
      "",
    );
    previewText = previewText.replace(/View Follow-ups\s*(->|→)/gi, "");

    // 3. Remove all other HTML tags (like <br>, <p>, <div>, etc.)
    previewText = previewText.replace(/<\/?[^>]+(>|$)/g, " ");

    // 4. Clean up any extra spaces left behind
    previewText = previewText.replace(/\s+/g, " ").trim();

    return previewText || "Click to view notification details...";
  };

  const formatTimeAgo = (date: string) => {
    const now = new Date();
    const created = new Date(date);
    const diffSeconds = Math.floor((now.getTime() - created.getTime()) / 1000);

    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    const formattedDate = created.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

    if (diffSeconds < 60) {
      return "Just now";
    }

    if (diffMinutes < 60) {
      return `${diffMinutes} min ago`;
    }

    if (diffHours < 24) {
      return `${diffHours} hr ago`;
    }

    if (diffDays === 1) {
      return `Yesterday • ${formattedDate}`;
    }

    return `${diffDays} days ago • ${formattedDate}`;
  };

  const notificationIconMap = {
    task_updated: {
      icon: "🔄",
      bg: "#ede9fe",
      color: "#7c3aed",
    },
    task_assigned: {
      icon: "🔔",
      bg: "#dbeafe",
      color: "#2563eb",
    },
    lead_assigned: {
      icon: "🔔",
      bg: "#dbeafe",
      color: "#2563eb",
    },
    lead_updated: {
      icon: "🔄",
      bg: "#ede9fe",
      color: "#7c3aed",
    },
    reminder: {
      icon: "⏰",
      bg: "#fff7ed",
      color: "#ea580c",
    },
    default: {
      icon: "📌",
      bg: "#e5e7eb",
      color: "#6b7280",
    },
  };

  const getNotificationStyle = (log: any) => {
    return (
      notificationIconMap[log.type as keyof typeof notificationIconMap] ||
      notificationIconMap.default
    );
  };

  const filteredNotifications = showUnreadOnly
    ? notifications.filter((n) => !n.read)
    : notifications;

  const getNotificationGroupLabel = (dateStr: string) => {
    const today = new Date();
    const date = new Date(dateStr);

    const isSameDay = (d1: Date, d2: Date) =>
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();

    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (isSameDay(date, today)) return "Today";
    if (isSameDay(date, yesterday)) return "Yesterday";

    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const groupedNotifications = filteredNotifications.reduce(
    (groups: Record<string, typeof filteredNotifications>, log) => {
      const label = getNotificationGroupLabel(log.createdAt);

      if (!groups[label]) {
        groups[label] = [];
      }

      groups[label].push(log);
      return groups;
    },
    {},
  );

  const orderedGroupedNotifications = Object.entries(groupedNotifications).sort(
    ([labelA], [labelB]) => {
      const parseLabelDate = (label: string) => {
        if (label === "Today") return new Date();
        if (label === "Yesterday") {
          const d = new Date();
          d.setDate(d.getDate() - 1);
          return d;
        }
        return new Date(label);
      };

      return (
        parseLabelDate(labelB).getTime() - parseLabelDate(labelA).getTime()
      );
    },
  );

  const toggleGroup = (groupLabel: string) => {
    setCollapsedGroups((prev) => ({
      ...prev,
      [groupLabel]: !prev[groupLabel],
    }));
  };

  // const isMoreThanTwoLines = (el: HTMLDivElement | null) => {
  //   if (!el) return false;
  //   return el.scrollHeight > el.clientHeight;
  // };

  // const contentRefs = React.useRef<Record<string, HTMLDivElement | null>>({});

  // Get button configuration
  const buttonConfig = getButtonConfig();

  const EllipsisTooltip = ({ value }: { value: string }) => {
    const ref = React.useRef<HTMLSpanElement | null>(null);
    const [showTooltip, setShowTooltip] = React.useState(false);

    React.useEffect(() => {
      const el = ref.current;
      if (!el) return;

      setShowTooltip(el.scrollWidth > el.clientWidth);
    }, [value]);

    return (
      <Tooltip title={showTooltip ? value : ""}>
        <span
          ref={ref}
          style={{
            maxWidth: "115px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "inline-block",
            verticalAlign: "middle",
            cursor: showTooltip ? "pointer" : "default",
          }}
        >
          {value}
        </span>
      </Tooltip>
    );
  };

  return (
    <>
      <Header className="header" style={{ padding: "0 16px" }}>
        <Row justify="space-between" align="middle" gutter={[16, 16]}>
          <Col xs={4} sm={3} md={2} lg={1}>
            <Button
              type="text"
              icon={<MenuOutlined style={{ fontSize: "20px" }} />}
              style={{ background: "transparent" }}
              onClick={toggleSidebar}
            />
          </Col>

          <Col>
            <Row align="middle" gutter={16}>
              <Col>
                <Badge count={unreadCount} overflowCount={99}>
                  <BellOutlined
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#444",
                    }}
                    onClick={() => setNotificationDrawerOpen(true)}
                  />
                </Badge>
              </Col>

              {/* Profile avatar hidden — moved to sidebar profile footer */}
            </Row>
          </Col>
        </Row>
      </Header>

      <Drawer
        title={null}
        placement="right"
        width={420}
        open={notificationDrawerOpen}
        onClose={() => setNotificationDrawerOpen(false)}
        bodyStyle={{ padding: 0, background: "#f9fafb" }}
      >
        {/* ===== HEADER ===== */}
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            background: "#ffffff",
            padding: "16px 20px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <div style={{ fontSize: 18, fontWeight: 600, color: "#111827" }}>
            Notifications
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            {/* ===== SINGLE BUTTON THAT TOGGLES ===== */}
            {buttonConfig && (
              <Tooltip title={buttonConfig.tooltip}>
                <Button
                  size="small"
                  loading={isUpdating}
                  onClick={handleMarkAll}
                  icon={buttonConfig.icon}
                  style={{
                    backgroundColor: buttonConfig.color,
                    color: "white",
                    border: "none",
                    fontSize: 12,
                    fontWeight: 500,
                    borderRadius: "20px",
                    padding: "4px 12px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    boxShadow: buttonConfig.shadow,
                  }}
                  className={`hover:bg-${buttonConfig.hoverColor} transition-colors`}
                >
                  {buttonConfig.text}
                </Button>
              </Tooltip>
            )}

            {/* SWITCH */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginLeft: 4,
              }}
            >
              <span
                style={{
                  fontSize: 12,
                  color: showUnreadOnly ? "#2563eb" : "#6b7280",
                  fontWeight: 500,
                }}
              >
                Unread only
              </span>

              <Switch
                size="small"
                checked={showUnreadOnly}
                onChange={(checked) => setShowUnreadOnly(checked)}
                style={{
                  backgroundColor: showUnreadOnly ? "#2563eb" : "#d9d9d9",
                }}
              />
            </div>
          </div>
        </div>

        {/* ===== CONTENT ===== */}
        <div>
          {Object.keys(groupedNotifications).length > 0 ? (
            orderedGroupedNotifications
              .slice(0, visibleGroupCount)
              .map(([groupLabel, logs]) => (
                <div key={groupLabel}>
                  {/* GROUP HEADER */}
                  <div
                    onClick={() => toggleGroup(groupLabel)}
                    style={{
                      padding: "8px 20px",
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#6b7280",
                      background: "#f3f4f6",
                      textTransform: "uppercase",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: "pointer",
                    }}
                  >
                    <span>{groupLabel}</span>

                    <RightOutlined
                      className={`text-xs transition-transform duration-300 ${
                        collapsedGroups[groupLabel] ? "rotate-0" : "rotate-90"
                      }`}
                    />
                  </div>

                  {/* GROUP ITEMS */}
                  <div
                    className={`overflow-hidden transition-all ease-in-out
                      ${
                        collapsedGroups[groupLabel]
                          ? "max-h-0 opacity-0 scale-y-95"
                          : "opacity-100 scale-y-100"
                      }
                      duration-500`}
                  >
                    {logs.map((log) => {
                      const iconStyle = getNotificationStyle(log);

                      return (
                        <div
                          key={log._id}
                          onClick={() => handleNotificationClick(log)}
                          onMouseEnter={() => setHoveredNotificationId(log._id)}
                          onMouseLeave={() => setHoveredNotificationId(null)}
                          style={{
                            display: "flex",
                            gap: 12,
                            padding: "14px 20px",
                            cursor: "pointer",
                            backgroundColor: log.read ? "#ffffff" : "#eef6ff",
                            borderBottom: "1px solid #e5e7eb",
                          }}
                        >
                          {/* ICON */}
                          <div
                            style={{
                              width: 38,
                              height: 38,
                              borderRadius: "50%",
                              background: iconStyle.bg,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 16,
                              color: iconStyle.color,
                              flexShrink: 0,
                            }}
                          >
                            {iconStyle.icon}
                          </div>

                          {/* CONTENT */}
                          <div style={{ flex: 1 }}>
                            <div
                              // ref={(el) => {
                              //   contentRefs.current[log._id] = el;
                              // }}
                              style={{
                                fontSize: 14,
                                fontWeight: log.read ? 400 : 600,
                                color: "#111827",
                                lineHeight: "1.45em",
                                maxHeight: "2.9em", // Always clamp height in the drawer
                                overflow: "hidden", // Always hide overflow
                                display: "-webkit-box", // Force flex box clamping
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2, // Always limit to 2 lines
                              }}
                              dangerouslySetInnerHTML={{
                                __html: getDrawerMessagePreview(log.message),
                              }}
                            />

                            <div
                              style={{
                                marginTop: 4,
                                fontSize: 12,
                                color: "#6b7280",
                              }}
                            >
                              {formatTimeAgo(log.createdAt)}
                            </div>
                          </div>

                          {/* ACTION */}
                          <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: 70,
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                          >
                            {!log.read && (
                              <span
                                style={{
                                  width: 8,
                                  height: 8,
                                  borderRadius: "50%",
                                  backgroundColor: "#2563eb",
                                }}
                              />
                            )}

                            {log.read && hoveredNotificationId === log._id && (
                              <button
                                className="unread-btn"
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  try {
                                    markAsUnread(log._id);
                                    await updateNotification(log._id, false);
                                  } catch (error) {
                                    console.error(
                                      "Error marking as unread:",
                                      error,
                                    );
                                  }
                                }}
                                style={{
                                  border: "1px solid #d9d9d9",
                                  background: "white",
                                  borderRadius: "12px",
                                  padding: "2px 8px",
                                  fontSize: "11px",
                                  color: "#ef4444",
                                  cursor: "pointer",
                                }}
                              >
                                Unread
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))
          ) : (
            <div
              style={{
                padding: "48px",
                textAlign: "center",
                color: "#9ca3af",
                fontSize: 14,
              }}
            >
              No notifications
            </div>
          )}
        </div>

        {visibleGroupCount < orderedGroupedNotifications.length && (
          <div className="flex justify-center py-4">
            <button
              onClick={() => setVisibleGroupCount((prev) => prev + 3)}
              style={{
                width: "calc(100% - 40px)",
                margin: "0 20px",
                padding: "8px 16px",
                border: "1px solid #e5e7eb",
                borderRadius: "20px",
                backgroundColor: "white",
                color: "#2563eb",
                fontSize: "13px",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              className="hover:bg-gray-50 hover:border-gray-300"
            >
              More Notifications
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
          </div>
        )}
      </Drawer>

      {/* Notification Modal */}
      <Modal
        width={selectedNotification && (() => {
          const nt = String(selectedNotification?.type || "").toLowerCase().replace(/[^a-z0-9]/g, "");
          const nm = String(selectedNotification?.title || "").toLowerCase().replace(/[^a-z0-9]/g, "");
          const nmsg = String(selectedNotification?.message || "").toLowerCase().replace(/[^a-z0-9]/g, "");
          const isFU = nt === "missfollowup" || nm.includes("missedfollow") || nmsg.includes("missedfollow") || nt === "todayfollowup" || (nm.includes("today") && nm.includes("follow")) || nmsg.includes("followupsscheduledtoday");
          return isFU ? 900 : 840;
        })()}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        destroyOnClose
        style={{ top: 57 }}
        styles={{ body: { padding: 0 } }}
        title={null}
        closable={false}
      >
        {selectedNotification &&
          (() => {
            const iconStyle = getNotificationStyle(selectedNotification);

            const notifType = String(selectedNotification.type || "")
              .toLowerCase()
              .replace(/[^a-z0-9]/g, "");

            const changes: any[] = Array.isArray(selectedNotification.changes)
              ? selectedNotification.changes
              : [];

            const details = selectedNotification.details || {};
            const isTask = notifType.includes("task");
            const isLead = notifType.includes("lead");
            const normalizedTitle = String(selectedNotification.title || "")
              .toLowerCase()
              .replace(/[^a-z0-9]/g, "");
            const normalizedMessage = String(selectedNotification.message || "")
              .toLowerCase()
              .replace(/[^a-z0-9]/g, "");
            const isMissFollowUp =
              notifType === "missfollowup" ||
              normalizedTitle.includes("missedfollow") ||
              normalizedMessage.includes("missedfollow");
            const isTodayFollowUp =
              notifType === "todayfollowup" ||
              (normalizedTitle.includes("today") &&
                normalizedTitle.includes("follow")) ||
              normalizedMessage.includes("followupsscheduledtoday");
            const isFollowUpNotification = isMissFollowUp || isTodayFollowUp;
            const isTaskCreate =
              notifType.includes("taskcreated") ||
              normalizedTitle.includes("newtaskcreated");
            const isLeadCreate =
              notifType.includes("leadcreated") ||
              normalizedTitle.includes("newleadcreated");
            const isCreateNotification = isTaskCreate || isLeadCreate;

            const parseHtmlTableToChanges = (msg: string) => {
              if (!msg) return [];

              const parser = new DOMParser();
              const doc = parser.parseFromString(msg, "text/html");
              const rows = Array.from(doc.querySelectorAll("table tr"));

              if (rows.length < 2) return [];

              const headers = Array.from(rows[0].querySelectorAll("th,td")).map(
                (th) =>
                  th.textContent?.trim().toLowerCase().replace(/\s+/g, "") ||
                  "",
              );

              const fieldIdx = headers.findIndex((h) =>
                ["changedproperty", "property", "field", "change"].includes(h),
              );
              const prevIdx = headers.findIndex((h) =>
                ["previous", "old", "oldvalue", "from"].includes(h),
              );
              const newIdx = headers.findIndex((h) =>
                ["new", "current", "newvalue", "to"].includes(h),
              );
              const idIdx = headers.findIndex((h) =>
                ["id", "leadid", "taskid"].includes(h),
              );
              const titleIdx = headers.findIndex((h) =>
                ["title", "task", "name"].includes(h),
              );
              const updatedByIdx = headers.findIndex((h) =>
                ["updatedby", "changedby", "user"].includes(h),
              );

              if (fieldIdx < 0 || prevIdx < 0 || newIdx < 0) return [];

              return rows.slice(1).map((row) => {
                const cells = Array.from(row.querySelectorAll("td"));

                return {
                  field: cells[fieldIdx]?.textContent?.trim() || "",
                  previous: cells[prevIdx]?.textContent?.trim() || "N/A",
                  current: cells[newIdx]?.textContent?.trim() || "N/A",
                  entityId: idIdx >= 0 ? cells[idIdx]?.textContent?.trim() : "",
                  entityTitle:
                    titleIdx >= 0 ? cells[titleIdx]?.textContent?.trim() : "",
                  updatedBy:
                    updatedByIdx >= 0
                      ? cells[updatedByIdx]?.textContent?.trim()
                      : "",
                };
              });
            };

            const parseHtmlTableToFollowUps = (msg: string) => {
              if (!msg) return [];

              const parser = new DOMParser();
              const doc = parser.parseFromString(msg, "text/html");
              const rows = Array.from(doc.querySelectorAll("table tr"));

              if (rows.length < 2) return [];

              const normalize = (value: string) =>
                value.toLowerCase().replace(/[^a-z0-9]/g, "");
              const headers = Array.from(rows[0].querySelectorAll("th,td")).map(
                (th) => normalize(th.textContent?.trim() || ""),
              );
              const findIdx = (keys: string[]) =>
                headers.findIndex((header) => keys.includes(header));

              const leadIdx = findIdx([
                "lead",
                "leadid",
                "leadno",
                "leadnumber",
              ]);
              const clientIdx = findIdx(["client", "customer", "name"]);
              const companyIdx = findIdx(["company", "companyname"]);
              const dateIdx = findIdx(["date", "followupdate", "followup"]);
              const statusIdx = findIdx(["status", "leadstatus"]);
              const actionIdx = findIdx(["action", "view"]);

              return rows.slice(1).map((row) => {
                const cells = Array.from(row.querySelectorAll("td"));
                const actionCell =
                  actionIdx >= 0 ? cells[actionIdx] : cells[cells.length - 1];
                const actionUrl =
                  actionCell?.querySelector("a")?.getAttribute("href") || "";

                return {
                  leadCode:
                    leadIdx >= 0 ? cells[leadIdx]?.textContent?.trim() : "N/A",
                  client:
                    clientIdx >= 0
                      ? cells[clientIdx]?.textContent?.trim()
                      : "N/A",
                  company:
                    companyIdx >= 0
                      ? cells[companyIdx]?.textContent?.trim()
                      : "N/A",
                  followUpDate:
                    dateIdx >= 0 ? cells[dateIdx]?.textContent?.trim() : "N/A",
                  status:
                    statusIdx >= 0
                      ? cells[statusIdx]?.textContent?.trim()
                      : "N/A",
                  actionUrl,
                };
              });
            };

            const extractFollowUpUrl = (msg: string) => {
              if (!msg) return null;

              const parser = new DOMParser();
              const doc = parser.parseFromString(msg, "text/html");
              const links = Array.from(doc.querySelectorAll("a"))
                .map((link) => link.getAttribute("href") || "")
                .filter((href) => href.includes("/rawdata?lead="));

              return (
                links.find(
                  (href) => href.includes("%2C") || href.includes(","),
                ) ||
                links[links.length - 1] ||
                null
              );
            };

            const followUpRows = isFollowUpNotification
              ? parseHtmlTableToFollowUps(selectedNotification.message || "")
              : [];
            const followUpUrl = isFollowUpNotification
              ? extractFollowUpUrl(selectedNotification.message || "")
              : null;

            const resolvedChanges =
              changes.length > 0
                ? changes
                : parseHtmlTableToChanges(selectedNotification.message || "");

            const firstRow = resolvedChanges[0] || {};

            const entityId = details.entityId || firstRow.entityId || "N/A";
            const entityTitle =
              details.entityTitle || firstRow.entityTitle || "N/A";
            const updatedBy = details.updatedBy || firstRow.updatedBy || "N/A";

            const entityMongoId = details.entityMongoId || null;
            const fallbackId =
              details.entityId && /^[a-f0-9]{24}$/i.test(details.entityId)
                ? details.entityId
                : null;

            const resolvedId = entityMongoId || fallbackId;

            const navigateUrl = isFollowUpNotification
              ? followUpUrl
              : isTask
                ? resolvedId
                  ? `/tasks?id=${resolvedId}`
                  : null
                : isLead
                  ? resolvedId
                    ? `/rawdata?lead=${resolvedId}`
                    : null
                  : null;

            const stripHtmlTags = (value: any) => {
              if (value === undefined || value === null || value === "")
                return "N/A";

              return String(value)
                .replace(/<[^>]*>/g, "")
                .replace(/&nbsp;/g, " ")
                .replace(/&amp;/g, "&")
                .trim();
            };

            const decodeNotificationHtml = (value: any) =>
              String(value ?? "")
                .replace(/&amp;/g, "&")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'");

            type DailyTaskStatusKey = "todo" | "inProgress" | "review" | "hold";
            type TaskStatusSummaryKey = DailyTaskStatusKey | "completed";

            const dailyTaskStatusColumns: Array<{
              key: DailyTaskStatusKey;
              label: string;
              color: string;
              bg: string;
            }> = [
              {
                key: "todo",
                label: "TO DO",
                color: "#b7791f",
                bg: "#fffbeb",
              },
              {
                key: "inProgress",
                label: "In Progress",
                color: "#0e7490",
                bg: "#ecfeff",
              },
              {
                key: "review",
                label: "Review",
                color: "#9333ea",
                bg: "#faf5ff",
              },
              {
                key: "hold",
                label: "Hold",
                color: "#ef4444",
                bg: "#fff1f2",
              },
            ];

            const normalizeTaskStatusKey = (
              value: any,
            ): TaskStatusSummaryKey | null => {
              const key = stripHtmlTags(decodeNotificationHtml(value))
                .toLowerCase()
                .replace(/[^a-z0-9]/g, "");

              if (!key || key === "na") return null;
              if (key.includes("completed") || key === "done")
                return "completed";
              if (key.includes("inprogress") || key.includes("progress"))
                return "inProgress";
              if (key.includes("todo")) return "todo";
              if (key.includes("review")) return "review";
              if (key.includes("hold")) return "hold";

              return null;
            };

            const readTaskCount = (value: any, fallback = 0): number => {
              if (typeof value === "number" && Number.isFinite(value)) {
                return Math.max(0, value);
              }

              if (Array.isArray(value)) return value.length;

              if (value && typeof value === "object") {
                const nestedCount =
                  value.count ??
                  value.total ??
                  value.value ??
                  value.taskCount ??
                  value.tasksCount ??
                  value.length;

                if (nestedCount !== undefined) {
                  return readTaskCount(nestedCount, fallback);
                }

                if (Array.isArray(value.tasks)) return value.tasks.length;
              }

              const match = stripHtmlTags(decodeNotificationHtml(value)).match(
                /\d+/,
              );
              return match ? Number(match[0]) : fallback;
            };

            const buildDailyTaskSummary = () => {
              const d = selectedNotification.details || {};
              if (d.totalCount !== undefined) {
                return {
                  counts: {
                    todo: d.todoCount || 0,
                    inProgress: d.inProgressCount || 0,
                    review: d.reviewCount || 0,
                    hold: d.holdCount || 0,
                  },
                  total: d.totalCount || 0,
                  calculatedTotal:
                    d.todoCount +
                    d.inProgressCount +
                    d.reviewCount +
                    d.holdCount,
                  matchedNonCompletedStatuses: 4,
                };
              }

              const counts: Record<DailyTaskStatusKey, number> = {
                todo: 0,
                inProgress: 0,
                review: 0,
                hold: 0,
              };
              const matchedStatuses: TaskStatusSummaryKey[] = [];
              let explicitTotal: number | null = null;

              const addStatusCount = (status: any, countValue: any = 1) => {
                const statusKey = normalizeTaskStatusKey(status);
                if (!statusKey) return;

                if (!matchedStatuses.includes(statusKey)) {
                  matchedStatuses.push(statusKey);
                }

                if (statusKey === "completed") return;

                counts[statusKey] += readTaskCount(countValue, 0);
              };

              const readStatusCounts = (source: any, depth = 0) => {
                if (!source || depth > 4) return;

                if (Array.isArray(source)) {
                  source.forEach((item) => {
                    if (item && typeof item === "object") {
                      const statusValue =
                        item.status ??
                        item.statusName ??
                        item.taskStatus ??
                        item.board ??
                        item.boardName ??
                        item.boardId?.name ??
                        item.name ??
                        item.label ??
                        item.title;
                      const countValue =
                        item.count ??
                        item.total ??
                        item.value ??
                        item.taskCount ??
                        item.tasksCount ??
                        (Array.isArray(item.tasks)
                          ? item.tasks.length
                          : undefined);

                      if (statusValue !== undefined) {
                        addStatusCount(
                          statusValue,
                          countValue === undefined ? 1 : countValue,
                        );
                      } else {
                        readStatusCounts(item, depth + 1);
                      }

                      return;
                    }

                    addStatusCount(item, 1);
                  });
                  return;
                }

                if (typeof source !== "object") return;

                const statusValue =
                  source.status ??
                  source.statusName ??
                  source.taskStatus ??
                  source.board ??
                  source.boardName ??
                  source.boardId?.name ??
                  source.name ??
                  source.label ??
                  source.title;
                const countValue =
                  source.count ??
                  source.total ??
                  source.value ??
                  source.taskCount ??
                  source.tasksCount;

                if (statusValue !== undefined && countValue !== undefined) {
                  addStatusCount(statusValue, countValue);
                }

                Object.entries(source).forEach(([key, value]) => {
                  const statusKey = normalizeTaskStatusKey(key);

                  if (statusKey) {
                    addStatusCount(key, value);
                    return;
                  }

                  const normalizedKey = key
                    .toLowerCase()
                    .replace(/[^a-z0-9]/g, "");
                  const shouldReadNested =
                    value &&
                    typeof value === "object" &&
                    (normalizedKey.includes("task") ||
                      normalizedKey.includes("status") ||
                      normalizedKey.includes("count") ||
                      normalizedKey.includes("summary") ||
                      ["details", "data", "metadata", "payload"].includes(
                        normalizedKey,
                      ));

                  if (shouldReadNested) readStatusCounts(value, depth + 1);
                });
              };

              const parseHtmlSummary = (msg: string) => {
                const decodedMessage = decodeNotificationHtml(msg);
                if (
                  !decodedMessage ||
                  !decodedMessage.toLowerCase().includes("<table")
                )
                  return;

                const parser = new DOMParser();
                const doc = parser.parseFromString(decodedMessage, "text/html");

                Array.from(doc.querySelectorAll("table")).forEach((table) => {
                  const rows = Array.from(table.querySelectorAll("tr"));
                  if (!rows.length) return;

                  const headers = Array.from(
                    rows[0].querySelectorAll("th,td"),
                  ).map((cell) =>
                    (cell.textContent || "")
                      .trim()
                      .toLowerCase()
                      .replace(/[^a-z0-9]/g, ""),
                  );
                  const bodyRows = rows.slice(1);
                  const statusHeaderIndexes = headers
                    .map((header, index) => ({
                      index,
                      statusKey: normalizeTaskStatusKey(header),
                    }))
                    .filter(({ statusKey }) => !!statusKey);
                  const totalHeaderIndex = headers.findIndex((header) =>
                    ["total", "totalcount", "tasks", "taskcount"].includes(
                      header,
                    ),
                  );

                  if (statusHeaderIndexes.length > 0) {
                    bodyRows.forEach((row) => {
                      const cells = Array.from(row.querySelectorAll("td"));
                      statusHeaderIndexes.forEach(({ index, statusKey }) => {
                        addStatusCount(statusKey, cells[index]?.textContent);
                      });

                      if (totalHeaderIndex >= 0) {
                        explicitTotal = readTaskCount(
                          cells[totalHeaderIndex]?.textContent,
                          explicitTotal ?? 0,
                        );
                      }
                    });
                    return;
                  }

                  const statusIdx = headers.findIndex((header) =>
                    [
                      "status",
                      "taskstatus",
                      "board",
                      "boardname",
                      "taskboard",
                    ].includes(header),
                  );
                  const countIdx = headers.findIndex((header) =>
                    [
                      "count",
                      "counts",
                      "taskcount",
                      "tasks",
                      "total",
                      "totalcount",
                    ].includes(header),
                  );

                  if (statusIdx >= 0) {
                    bodyRows.forEach((row) => {
                      const cells = Array.from(row.querySelectorAll("td"));
                      const statusText = cells[statusIdx]?.textContent;
                      addStatusCount(
                        statusText,
                        countIdx >= 0 ? cells[countIdx]?.textContent : 1,
                      );

                      if (normalizeTaskStatusKey(statusText) === "completed")
                        return;

                      if (
                        countIdx >= 0 &&
                        headers[countIdx]?.includes("total")
                      ) {
                        explicitTotal =
                          (explicitTotal ?? 0) +
                          readTaskCount(cells[countIdx]?.textContent, 0);
                      }
                    });
                    return;
                  }

                  rows.forEach((row) => {
                    const cells = Array.from(row.querySelectorAll("td"));
                    if (cells.length >= 2) {
                      addStatusCount(
                        cells[0]?.textContent,
                        cells[1]?.textContent,
                      );
                    }
                  });
                });
              };

              const parseTextSummary = (msg: string) => {
                const text = stripHtmlTags(decodeNotificationHtml(msg)).replace(
                  /\s+/g,
                  " ",
                );
                const patterns = [
                  { status: "todo", regex: /\bto[\s-]*do\b|\btodo\b/i },
                  {
                    status: "inProgress",
                    regex: /\bin[\s-]*progress\b|\binprogress\b/i,
                  },
                  { status: "review", regex: /\breview\b/i },
                  { status: "hold", regex: /\bhold\b/i },
                  { status: "completed", regex: /\bcompleted\b/i },
                ];

                patterns.forEach(({ status, regex }) => {
                  const statusThenCount = text.match(
                    new RegExp(
                      `(?:${regex.source})\\s*(?:tasks?)?\\s*[:=-]?\\s*(\\d+)`,
                      "i",
                    ),
                  );
                  const countThenStatus = text.match(
                    new RegExp(
                      `(\\d+)\\s*(?:tasks?)?\\s*(?:${regex.source})`,
                      "i",
                    ),
                  );
                  const match = statusThenCount || countThenStatus;

                  if (match) addStatusCount(status, match[1]);
                });

                const totalMatch =
                  text.match(/\btotal\s*(?:tasks?)?\s*[:=-]?\s*(\d+)/i) ||
                  text.match(/(\d+)\s*(?:total\s*)?tasks?\b/i);

                if (totalMatch && explicitTotal === null) {
                  explicitTotal = readTaskCount(totalMatch[1], 0);
                }
              };

              const notificationMessage = selectedNotification.message || "";
              const hasHtmlTable = decodeNotificationHtml(notificationMessage)
                .toLowerCase()
                .includes("<table");

              readStatusCounts(selectedNotification);
              parseHtmlSummary(notificationMessage);
              if (!hasHtmlTable) {
                parseTextSummary(notificationMessage);
              }

              const calculatedTotal =
                counts.todo + counts.inProgress + counts.review + counts.hold;
              const total = explicitTotal ?? calculatedTotal;
              const matchedNonCompletedStatuses = matchedStatuses.filter(
                (status) => status !== "completed",
              ).length;

              return {
                counts,
                total,
                calculatedTotal,
                matchedNonCompletedStatuses,
              };
            };

            const firstUsableNotificationValue = (...values: any[]) => {
              for (const value of values) {
                const rawValue =
                  value && typeof value === "object"
                    ? value.name || value.title || value.slug || value._id
                    : value;
                const text = stripHtmlTags(rawValue);

                if (
                  text &&
                  text.toLowerCase() !== "n/a" &&
                  !/^[a-f0-9]{24}$/i.test(text)
                ) {
                  return text;
                }
              }

              return "N/A";
            };

            const formatFieldName = (field: string) => {
              if (!field) return "Updated";

              return field
                .replace(/([A-Z])/g, " $1")
                .replace(/_/g, " ")
                .replace(/^./, (s) => s.toUpperCase())
                .trim();
            };

            const thStyle: React.CSSProperties = {
              padding: "16px 14px",
              background: "#f3f4f6",
              color: "#374151",
              fontSize: 14,
              fontWeight: 700,
              borderRight: "1px solid #e5e7eb",
              textAlign: "left",
            };

            const tdStyle: React.CSSProperties = {
              padding: "16px 14px",
              borderTop: "1px solid #e5e7eb",
              borderRight: "1px solid #e5e7eb",
              fontSize: 14,
              color: "#374151",
              verticalAlign: "middle",
            };

            // const valueStyle = (value: any): React.CSSProperties => ({
            //   fontWeight: 600,
            //   color: getStatusColor(stripHtmlTags(value)),
            // });

            const getValueBadgeStyle = (
              value: any,
              field: any,
            ): React.CSSProperties => {
              const text = String(stripHtmlTags(value) || "")
                .toLowerCase()
                .trim();
              const fieldName = String(field || "").toLowerCase();

              let color = "#374151";
              let bg = "#f3f4f6";

              if (fieldName.includes("status")) {
                const matchedStatus = leadStatuses.find((s: any) => {
                  const name = String(s.name || "").toLowerCase();
                  const slug = String(s.slug || "").toLowerCase();
                  return name === text || slug === text.replace(/\s+/g, "-");
                });

                if (matchedStatus?.color) {
                  color = matchedStatus.color;
                  bg = `${matchedStatus.color}20`;
                } else if (text.includes("completed")) {
                  color = "#10b981";
                  bg = "#ecfdf5";
                } else if (text.includes("progress")) {
                  color = "#0e7490";
                  bg = "#ecfeff";
                } else if (text.includes("to do") || text.includes("todo")) {
                  color = "#b7791f";
                  bg = "#fffbeb";
                } else if (
                  text.includes("pending") ||
                  text.includes("qualified")
                ) {
                  color = "#f59e0b";
                  bg = "#fff7ed";
                } else if (text.includes("follow")) {
                  color = "#06b6d4";
                  bg = "#ecfeff";
                } else if (text.includes("proposal")) {
                  color = "#16a34a";
                  bg = "#dcfce7";
                } else if (
                  text.includes("meeting") ||
                  text.includes("cancel")
                ) {
                  color = "#ef4444";
                  bg = "#fff1f2";
                }
              }

              if (fieldName.includes("priority")) {
                if (text.includes("low")) {
                  color = "#10b981";
                  bg = "#ecfdf5";
                } else if (text.includes("medium")) {
                  color = "#0ea5e9";
                  bg = "#f0f9ff";
                } else if (text.includes("high")) {
                  color = "#ef4444";
                  bg = "#fff1f2";
                }
              }

              return {
                display: "inline-block",
                padding: "5px 10px",
                borderRadius: 6,
                fontWeight: 700,
                background: bg,
                color,
                border: `1px solid ${color}`,
              };
            };

            const getChangeDisplayValue = (change: any, value: any) => {
              const fieldKey = String(
                change.field || change.changedProperty || "",
              )
                .toLowerCase()
                .replace(/[^a-z0-9]/g, "");

              if (fieldKey.includes("photo")) {
                if (Array.isArray(value)) {
                  return value.length
                    ? `${value.length} photo${value.length === 1 ? "" : "s"}`
                    : "No photo";
                }

                const text = stripHtmlTags(value);
                const lowerText = text.toLowerCase();

                if (
                  !text ||
                  lowerText === "n/a" ||
                  lowerText === "no photo" ||
                  lowerText === "no photos"
                ) {
                  return "No photo";
                }

                return /^\d+\s+photos?$/.test(lowerText)
                  ? text
                  : "Photo attached";
              }

              return stripHtmlTags(value) || "N/A";
            };

            const visibleChanges = resolvedChanges.filter((change: any) => {
              const previous = getChangeDisplayValue(change, change.previous);
              const current = getChangeDisplayValue(
                change,
                change.current || change.new,
              );

              return previous !== current;
            });

            const taskDescriptionValue = firstUsableNotificationValue(
              details.description,
              details.taskDescription,
              details.taskDesc,
              notificationTaskDetails?.taskDesc,
              notificationTaskDetails?.description,
            );
            const taskStatusValue = firstUsableNotificationValue(
              details.status,
              details.statusName,
              details.taskStatus,
              details.board,
              details.boardName,
              notificationTaskDetails?.status,
              notificationTaskDetails?.boardName,
              notificationTaskDetails?.boardId?.name,
              notificationTaskDetails?.boardId?.slug,
              notificationTaskDetails?.boardId,
            );
            const dailyTaskSummary = buildDailyTaskSummary();
            const isTaskRelatedNotification =
              isTask ||
              normalizedTitle.includes("task") ||
              normalizedMessage.includes("task");
            const hasDailyTaskSignal =
              notifType.includes("daily") ||
              notifType.includes("cron") ||
              normalizedTitle.includes("dailytask") ||
              normalizedTitle.includes("todaytask") ||
              normalizedTitle.includes("todaystask") ||
              normalizedTitle.includes("tasksfortoday") ||
              normalizedTitle.includes("workloadsummary") ||
              normalizedTitle.includes("tasknotification") ||
              normalizedTitle.includes("tasksnotification") ||
              normalizedMessage.includes("dailytask") ||
              normalizedMessage.includes("todaytask") ||
              normalizedMessage.includes("todaystask") ||
              normalizedMessage.includes("tasksfortoday") ||
              normalizedMessage.includes("workloadsummary") ||
              normalizedMessage.includes("totaltasks") ||
              normalizedMessage.includes("tasknotification") ||
              normalizedMessage.includes("tasksnotification") ||
              normalizedMessage.includes("cron");
            const isDailyTaskNotification =
              !isCreateNotification &&
              isTaskRelatedNotification &&
              (hasDailyTaskSignal ||
                dailyTaskSummary.total > 0 ||
                dailyTaskSummary.matchedNonCompletedStatuses > 1);

            return (
              <>
                {/* ── TOP DARK SECTION: header row + stats row ── */}
                <div style={{
                  background: "#0d1b2e",
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                  paddingBottom: isFollowUpNotification ? 0 : 0,
                }}>

                  {/* ── HEADER ROW ── */}
                  <div style={{
                    padding: "22px 28px 20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                      {isFollowUpNotification ? (
                        /* Warm dark-brown/orange rounded-square — matches target exactly */
                        <div style={{
                          width: 56, height: 56, borderRadius: 14,
                          background: "#3a230f",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          flexShrink: 0,
                        }}>
                          {/* Ringing bell — react-icons/pi, bright orange, matches target */}
                          <PiBellRingingThin style={{ color: "#fb8c2e", fontSize: 30 }} />
                        </div>
                      ) : (
                        <div style={{
                          width: 54, height: 54, borderRadius: "50%",
                          background: iconStyle.bg, color: iconStyle.color,
                          display: "flex", alignItems: "center", justifyContent: "center",
                          fontSize: 22, flexShrink: 0,
                        }}>
                          {iconStyle.icon}
                        </div>
                      )}

                      <div>
                        <div style={{ color: "#ffffff", fontSize: 21, fontWeight: 700, letterSpacing: "-0.2px" }}>
                          {isFollowUpNotification
                            ? selectedNotification.title || "Missed Follow-ups Reminder"
                            : isDailyTaskNotification
                              ? "Daily Tasks"
                              : isTaskCreate
                                ? "New Task Created"
                                : isLeadCreate
                                  ? "New Lead Created"
                                  : isTask
                                    ? "Task Updated"
                                    : isLead
                                      ? "Lead Updated"
                                      : "Notification"}
                        </div>
                        <div style={{ color: "#6b7f99", fontSize: 13, marginTop: 5, display: "flex", alignItems: "center", gap: 7 }}>
                          <span>{formatTimeAgo(selectedNotification.createdAt)}</span>
                          {isFollowUpNotification && (
                            <>
                              <span>•</span>
                              <span>Stay on top of your pending follow-ups</span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <CloseOutlined
                      onClick={() => setModalVisible(false)}
                      style={{ color: "#6b7f99", fontSize: 16, cursor: "pointer" }}
                    />
                  </div>

                  {/* ── STATS ROW (follow-up only) ── */}
                  {isFollowUpNotification && (() => {
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  const todayCount = followUpRows.filter((r: any) => {
                    const d = new Date(r.followUpDate);
                    d.setHours(0, 0, 0, 0);
                    return d.getTime() === today.getTime();
                  }).length;
                  const overdueCount = followUpRows.filter((r: any) => {
                    const d = new Date(r.followUpDate);
                    d.setHours(0, 0, 0, 0);
                    return d.getTime() < today.getTime();
                  }).length;
                  const upcomingCount = followUpRows.filter((r: any) => {
                    const d = new Date(r.followUpDate);
                    d.setHours(0, 0, 0, 0);
                    return d.getTime() > today.getTime();
                  }).length;
                  return (
                    <>
                      {/* thin horizontal divider between header and stats */}
                      <div style={{ height: "1px", background: "rgba(255,255,255,0.07)", margin: "0 0" }} />

                      <div style={{
                        padding: "18px 28px 22px",
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        rowGap: 14,
                      }}>
                        {/* Left: envelope icon + count text */}
                        <div style={{ display: "flex", alignItems: "center", gap: 14, flex: 1, minWidth: 200 }}>
                          <div style={{
                            width: 44, height: 44, borderRadius: 11,
                            background: "transparent",
                            border: "1px solid rgba(255,255,255,0.18)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            flexShrink: 0,
                          }}>
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fb8c2e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <rect x="2" y="4" width="20" height="16" rx="2"/>
                              <path d="M22 7l-10 7L2 7"/>
                            </svg>
                          </div>
                          <div style={{ lineHeight: 1.5 }}>
                            <div style={{ color: "#b8c8dc", fontSize: 14, fontWeight: 400 }}>
                              You have{" "}
                              <span style={{ color: "#fb8c2e", fontWeight: 700, fontSize: 20 }}>
                                {followUpRows.length}
                              </span>{" "}
                              follow-ups
                            </div>
                            <div style={{ color: "#4e6278", fontSize: 12 }}>pending your attention</div>
                          </div>
                        </div>

                        {/* Right: 3 stats with thin vertical dividers between them */}
                        <div style={{ display: "flex", alignItems: "center" }}>

                          {/* Today */}
                          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "0 28px 0 0" }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <rect x="3" y="4" width="18" height="18" rx="2"/>
                              <line x1="16" y1="2" x2="16" y2="6"/>
                              <line x1="8" y1="2" x2="8" y2="6"/>
                              <line x1="3" y1="10" x2="21" y2="10"/>
                            </svg>
                            <div>
                              <div style={{ color: "#4e6278", fontSize: 11, fontWeight: 400, lineHeight: 1.3 }}>Today</div>
                              <div style={{ color: "#ffffff", fontWeight: 600, fontSize: 22, lineHeight: 1.1, fontFamily: "inherit" }}>{todayCount}</div>
                            </div>
                          </div>

                          {/* vertical divider */}
                          <div style={{ width: "1px", height: 36, background: "rgba(255,255,255,0.12)", flexShrink: 0 }} />

                          {/* Overdue */}
                          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "0 28px" }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <circle cx="12" cy="12" r="10"/>
                              <polyline points="12 6 12 12 16 14"/>
                            </svg>
                            <div>
                              <div style={{ color: "#4e6278", fontSize: 11, fontWeight: 400, lineHeight: 1.3 }}>Overdue</div>
                              <div style={{ color: "#ffffff", fontWeight: 600, fontSize: 22, lineHeight: 1.1, fontFamily: "inherit" }}>{overdueCount}</div>
                            </div>
                          </div>

                          {/* vertical divider */}
                          <div style={{ width: "1px", height: 36, background: "rgba(255,255,255,0.12)", flexShrink: 0 }} />

                          {/* Upcoming */}
                          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "0 0 0 28px" }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <rect x="3" y="4" width="18" height="18" rx="2"/>
                              <line x1="16" y1="2" x2="16" y2="6"/>
                              <line x1="8" y1="2" x2="8" y2="6"/>
                              <line x1="3" y1="10" x2="21" y2="10"/>
                              <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"/>
                            </svg>
                            <div>
                              <div style={{ color: "#4e6278", fontSize: 11, fontWeight: 400, lineHeight: 1.3 }}>Upcoming</div>
                              <div style={{ color: "#ffffff", fontWeight: 600, fontSize: 22, lineHeight: 1.1, fontFamily: "inherit" }}>{upcomingCount}</div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </>
                  );
                })()}
                </div>{/* end outer dark wrapper */}

                <div style={{ padding: isFollowUpNotification ? "0" : "18px 18px 0", fontSize: 16, color: "#374151" }}>
                  {!isFollowUpNotification && (
                    isDailyTaskNotification
                      ? "Task status count:"
                      : isTaskCreate
                        ? "Task created:"
                        : isLeadCreate
                          ? "Lead created:"
                          : isTask
                            ? "Task updates:"
                            : isLead
                              ? "Lead updates:"
                              : "Updates:"
                  )}
                </div>

                <div style={{ padding: isFollowUpNotification ? "0" : "18px" }}>
                  <div
                    style={isFollowUpNotification ? {} : {
                      border: "1px solid #e5e7eb",
                      borderRadius: 8,
                      overflow: "hidden",
                    }}
                  >
                    {isDailyTaskNotification ? (
                      <table
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr>
                            {dailyTaskStatusColumns.map((column) => (
                              <th key={column.key} style={thStyle}>
                                {column.label}
                              </th>
                            ))}
                            <th style={{ ...thStyle, borderRight: "none" }}>
                              Total
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            {dailyTaskStatusColumns.map((column) => (
                              <td
                                key={column.key}
                                style={{
                                  ...tdStyle,
                                  textAlign: "center",
                                  color: column.color,
                                  background: column.bg,
                                  fontSize: 22,
                                  fontWeight: 800,
                                }}
                              >
                                {dailyTaskSummary.counts[column.key] || 0}
                              </td>
                            ))}
                            <td
                              style={{
                                ...tdStyle,
                                borderRight: "none",
                                textAlign: "center",
                                color: "#001b35",
                                background: "#eff6ff",
                                fontSize: 22,
                                fontWeight: 800,
                              }}
                            >
                              {dailyTaskSummary.total}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ) : isFollowUpNotification ? (() => {
                      const today = new Date();
                      today.setHours(0, 0, 0, 0);

                      const getRelativeLabel = (dateStr: string) => {
                        if (!dateStr || dateStr === "N/A") return null;
                        const d = new Date(dateStr);
                        if (isNaN(d.getTime())) return null;
                        d.setHours(0, 0, 0, 0);
                        const diffDays = Math.round((d.getTime() - today.getTime()) / 86400000);
                        if (diffDays === 0) return { text: "Today", overdue: false };
                        if (diffDays > 0) {
                          if (diffDays === 1) return { text: "Due tomorrow", overdue: false };
                          if (diffDays < 7) return { text: `In ${diffDays} days`, overdue: false };
                          if (diffDays < 30) return { text: `In ${Math.ceil(diffDays / 7)} week${Math.ceil(diffDays / 7) > 1 ? "s" : ""}`, overdue: false };
                          if (diffDays < 365) return { text: `In ${Math.ceil(diffDays / 30)} month${Math.ceil(diffDays / 30) > 1 ? "s" : ""}`, overdue: false };
                          return { text: `In ${Math.ceil(diffDays / 365)} year${Math.ceil(diffDays / 365) > 1 ? "s" : ""}`, overdue: false };
                        }
                        const abs = Math.abs(diffDays);
                        if (abs === 1) return { text: "Overdue by 1 day", overdue: true };
                        if (abs < 7) return { text: `Overdue by ${abs} days`, overdue: true };
                        if (abs < 30) return { text: `Overdue by ${Math.ceil(abs / 7)} week${Math.ceil(abs / 7) > 1 ? "s" : ""}`, overdue: true };
                        return { text: `Overdue by ${Math.ceil(abs / 30)} month${Math.ceil(abs / 30) > 1 ? "s" : ""}`, overdue: true };
                      };

                      const formatFollowUpDate = (dateStr: string) => {
                        if (!dateStr || dateStr === "N/A") return "N/A";
                        const d = new Date(dateStr);
                        if (isNaN(d.getTime())) return dateStr;
                        return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
                      };

                      const totalPages = Math.ceil(followUpRows.length / FOLLOW_UP_PAGE_SIZE);
                      const currentPage = Math.min(followUpPage, totalPages || 1);
                      const startIdx = (currentPage - 1) * FOLLOW_UP_PAGE_SIZE;
                      const pageRows = followUpRows.slice(startIdx, startIdx + FOLLOW_UP_PAGE_SIZE);

                      const getPaginationPages = () => {
                        if (totalPages <= 5) return Array.from({ length: totalPages }, (_, i) => i + 1);
                        const pages: (number | "...")[] = [1];
                        if (currentPage > 3) pages.push("...");
                        for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) pages.push(i);
                        if (currentPage < totalPages - 2) pages.push("...");
                        pages.push(totalPages);
                        return pages;
                      };

                      return (
                        <div style={{ background: "#f1f5f9", padding: "16px 20px 0" }}>
                          {/* Table card with side margin & rounded corners */}
                          <div style={{
                            background: "#fff",
                            borderRadius: 12,
                            border: "1px solid #e2e8f0",
                            overflow: "hidden",
                          }}>
                          <div style={{ overflowX: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 620 }}>
                              <thead>
                                <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                                  {(["Lead #", "Client", "Company", "Follow-Up Date", "Status", "Action"] as string[]).map((col, i) => (
                                    <th key={col} style={{
                                      padding: "14px 16px",
                                      fontWeight: 600,
                                      fontSize: 13,
                                      color: "#64748b",
                                      textAlign: "left",
                                      whiteSpace: "nowrap",
                                      borderRight: i < 5 ? "1px solid #f1f5f9" : "none",
                                      background: "#f8fafc",
                                    }}>
                                      {col !== "Action" ? (
                                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                                          {col}
                                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5">
                                            <path d="M12 5v14M5 12l7-7 7 7"/>
                                          </svg>
                                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5" style={{ marginLeft: -6 }}>
                                            <path d="M12 19V5M5 12l7 7 7-7"/>
                                          </svg>
                                        </span>
                                      ) : col}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {pageRows.length > 0 ? pageRows.map((followUp: any, index: number) => {
                                  const rel = getRelativeLabel(followUp.followUpDate);
                                  const isDueIn2 = rel && !rel.overdue && rel.text.includes("2 days");
                                  return (
                                    <tr key={`${followUp.leadCode}-${startIdx + index}`}
                                      style={{ borderBottom: "1px solid #f1f5f9", background: "#fff", transition: "background 0.15s" }}
                                      onMouseEnter={e => (e.currentTarget.style.background = "#f8fafc")}
                                      onMouseLeave={e => (e.currentTarget.style.background = "#fff")}
                                    >
                                      {/* Lead # */}
                                      <td style={{ padding: "14px 16px", borderRight: "1px solid #f1f5f9", whiteSpace: "nowrap" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                          <div style={{
                                            width: 32, height: 32, borderRadius: 8,
                                            background: "#0f1f35",
                                            display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                          }}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                              <circle cx="12" cy="7" r="4"/>
                                            </svg>
                                          </div>
                                          <span style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>
                                            {followUp.leadCode || "N/A"}
                                          </span>
                                        </div>
                                      </td>
                                      {/* Client */}
                                      <td style={{ padding: "14px 16px", fontSize: 14, color: "#334155", borderRight: "1px solid #f1f5f9" }}>
                                        {followUp.client || "N/A"}
                                      </td>
                                      {/* Company */}
                                      <td style={{ padding: "14px 16px", fontSize: 14, color: "#334155", borderRight: "1px solid #f1f5f9" }}>
                                        {followUp.company || "N/A"}
                                      </td>
                                      {/* Follow-Up Date */}
                                      <td style={{ padding: "14px 16px", borderRight: "1px solid #f1f5f9", whiteSpace: "nowrap" }}>
                                        <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginTop: 2, flexShrink: 0 }}>
                                            <rect x="3" y="4" width="18" height="18" rx="2"/>
                                            <line x1="16" y1="2" x2="16" y2="6"/>
                                            <line x1="8" y1="2" x2="8" y2="6"/>
                                            <line x1="3" y1="10" x2="21" y2="10"/>
                                          </svg>
                                          <div>
                                            <div style={{ fontSize: 14, fontWeight: 500, color: "#0f172a" }}>
                                              {formatFollowUpDate(followUp.followUpDate)}
                                            </div>
                                            {rel && (
                                              <div style={{ fontSize: 12, color: rel.overdue || isDueIn2 ? "#ef4444" : "#64748b", marginTop: 1 }}>
                                                {rel.text}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </td>
                                      {/* Status */}
                                      <td style={{ padding: "14px 25px", borderRight: "1px solid #f1f5f9", width: 160, maxWidth: 160 }}>
                                        {(() => {
                                          const statusText = followUp.status || "N/A";
                                          const s = statusText.toLowerCase();
                                          let dotColor = "#f59e0b";
                                          let bg = "#fffbeb";
                                          let textColor = "#b45309";
                                          let borderColor = "#fde68a";
                                          if (s.includes("pending")) { dotColor = "#f59e0b"; bg = "#fffbeb"; textColor = "#b45309"; borderColor = "#fde68a"; }
                                          else if (s.includes("meeting") || s.includes("cancel")) { dotColor = "#ef4444"; bg = "#fff1f2"; textColor = "#ef4444"; borderColor = "#fecaca"; }
                                          else if (s.includes("completed") || s.includes("proposal")) { dotColor = "#10b981"; bg = "#ecfdf5"; textColor = "#059669"; borderColor = "#a7f3d0"; }
                                          else if (s.includes("follow") || s.includes("progress")) { dotColor = "#3b82f6"; bg = "#eff6ff"; textColor = "#2563eb"; borderColor = "#bfdbfe"; }
                                          return (
                                            <span style={{
                                              display: "inline-flex", alignItems: "center", gap: 6,
                                              padding: "5px 10px", borderRadius: 6,
                                              background: bg, color: textColor,
                                              border: `1px solid ${borderColor}`,
                                              fontSize: 13, fontWeight: 600,
                                              whiteSpace: "normal", wordBreak: "break-word",
                                              maxWidth: 140,
                                            }}>
                                              <span style={{ width: 7, height: 7, borderRadius: "50%", background: dotColor, display: "inline-block", flexShrink: 0, alignSelf: "center" }} />
                                              {statusText}
                                            </span>
                                          );
                                        })()}
                                      </td>
                                      {/* Action */}
                                      <td style={{ padding: "14px 16px" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                          {followUp.actionUrl && (
                                            <button
                                              onClick={() => { navigate(followUp.actionUrl); setModalVisible(false); setNotificationDrawerOpen(false); }}
                                              style={{
                                                display: "inline-flex", alignItems: "center", gap: 6,
                                                background: "#0f1f35", color: "#fff",
                                                border: "none", borderRadius: 7,
                                                padding: "7px 14px", fontSize: 13, fontWeight: 600,
                                                cursor: "pointer", whiteSpace: "nowrap",
                                              }}
                                            >
                                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                                <circle cx="12" cy="12" r="3"/>
                                              </svg>
                                              View
                                            </button>
                                          )}
                                          <button style={{
                                            background: "transparent", border: "none", cursor: "pointer",
                                            color: "#94a3b8", padding: "4px 2px", fontSize: 18, lineHeight: 1,
                                            display: "flex", alignItems: "center",
                                          }}>⋮</button>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                }) : (
                                  <tr>
                                    <td colSpan={6} style={{ padding: "32px", textAlign: "center", color: "#94a3b8", fontSize: 14 }}>
                                      No follow-ups available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>

                          {/* Pagination footer */}
                          <div style={{
                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            padding: "14px 20px", borderTop: "1px solid #f1f5f9",
                            background: "#fff", flexWrap: "wrap", gap: 12,
                          }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#64748b", fontSize: 13 }}>
                              <div style={{
                                width: 22, height: 22, borderRadius: "50%", background: "#f1f5f9",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: 11, color: "#64748b", fontWeight: 700, flexShrink: 0,
                              }}>i</div>
                              Showing {followUpRows.length === 0 ? 0 : startIdx + 1} to{" "}
                              {Math.min(startIdx + FOLLOW_UP_PAGE_SIZE, followUpRows.length)} of{" "}
                              {followUpRows.length} follow-ups
                            </div>
                            {totalPages > 1 && (
                              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                {/* Prev */}
                                <button
                                  onClick={() => setFollowUpPage(p => Math.max(1, p - 1))}
                                  disabled={currentPage === 1}
                                  style={{
                                    width: 32, height: 32, borderRadius: 6, border: "1px solid #e2e8f0",
                                    background: "#fff", cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                    color: currentPage === 1 ? "#cbd5e1" : "#475569",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                  }}
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>
                                </button>
                                {/* Pages */}
                                {getPaginationPages().map((page, idx) =>
                                  page === "..." ? (
                                    <span key={`ellipsis-${idx}`} style={{ width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8", fontSize: 14 }}>...</span>
                                  ) : (
                                    <button
                                      key={page}
                                      onClick={() => setFollowUpPage(page as number)}
                                      style={{
                                        width: 32, height: 32, borderRadius: 6,
                                        border: currentPage === page ? "none" : "1px solid #e2e8f0",
                                        background: currentPage === page ? "#0f1f35" : "#fff",
                                        color: currentPage === page ? "#fff" : "#475569",
                                        fontWeight: currentPage === page ? 700 : 400,
                                        fontSize: 13, cursor: "pointer",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                      }}
                                    >
                                      {page}
                                    </button>
                                  )
                                )}
                                {/* Next */}
                                <button
                                  onClick={() => setFollowUpPage(p => Math.min(totalPages, p + 1))}
                                  disabled={currentPage === totalPages}
                                  style={{
                                    width: 32, height: 32, borderRadius: 6, border: "1px solid #e2e8f0",
                                    background: "#fff", cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                                    color: currentPage === totalPages ? "#cbd5e1" : "#475569",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                  }}
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>
                                </button>
                              </div>
                            )}
                          </div>
                          </div>
                        </div>
                      );
                    })() : isCreateNotification ? (
                      <table
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr>
                            <th style={thStyle}>
                              {isTaskCreate ? "Task ID" : "ID"}
                            </th>
                            <th style={thStyle}>
                              {isTaskCreate ? "Task Name" : "Title"}
                            </th>
                            <th style={thStyle}>
                              {isTaskCreate ? "Description" : "Company"}
                            </th>
                            <th style={thStyle}>Priority</th>
                            {isTaskCreate && (
                              <th style={{ ...thStyle, borderRight: "none" }}>
                                Status
                              </th>
                            )}
                            {!isTaskCreate && (
                              <th style={{ ...thStyle, borderRight: "none" }}>
                                Created By
                              </th>
                            )}
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td style={tdStyle}>{entityId}</td>
                            <td style={{ ...tdStyle, fontWeight: 700 }}>
                              {entityTitle}
                            </td>
                            <td style={tdStyle}>
                              {isTaskCreate
                                ? stripHtmlTags(taskDescriptionValue)
                                : stripHtmlTags(details.company)}
                            </td>
                            <td style={tdStyle}>
                              <span
                                style={getValueBadgeStyle(
                                  details.priority,
                                  "priority",
                                )}
                              >
                                {stripHtmlTags(details.priority)}
                              </span>
                            </td>
                            {isTaskCreate && (
                              <td style={{ ...tdStyle, borderRight: "none" }}>
                                <span
                                  style={getValueBadgeStyle(
                                    taskStatusValue,
                                    "status",
                                  )}
                                >
                                  {stripHtmlTags(taskStatusValue)}
                                </span>
                              </td>
                            )}
                            {!isTaskCreate && (
                              <td style={{ ...tdStyle, borderRight: "none" }}>
                                {updatedBy}
                              </td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    ) : (
                      <table
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr>
                            <th style={thStyle}>ID</th>
                            <th style={thStyle}>Title</th>
                            <th style={thStyle}>Updated By</th>
                            <th style={thStyle}>Changed Property</th>
                            <th style={thStyle}>Previous</th>
                            <th style={{ ...thStyle, borderRight: "none" }}>
                              New
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {visibleChanges.length > 0 ? (
                            visibleChanges.map((change: any, index: number) => (
                              <tr key={index}>
                                <td style={tdStyle}>
                                  {change.entityId || entityId}
                                </td>

                                <td style={{ ...tdStyle, fontWeight: 700 }}>
                                  {change.entityTitle || entityTitle}
                                </td>

                                <td style={tdStyle}>
                                  {change.updatedBy || updatedBy}
                                </td>

                                <td style={tdStyle}>
                                  {formatFieldName(
                                    String(
                                      change.field ||
                                        change.changedProperty ||
                                        "",
                                    ),
                                  )}
                                </td>

                                <td
                                  style={{
                                    ...tdStyle,
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <Tooltip
                                    title={stripHtmlTags(change.previous)}
                                  >
                                    <span
                                      style={{
                                        ...getValueBadgeStyle(
                                          change.previous,
                                          change.field ||
                                            change.changedProperty,
                                        ),
                                        maxWidth: 120,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        display: "inline-block",
                                        verticalAlign: "middle",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {stripHtmlTags(change.previous) || "N/A"}
                                    </span>
                                  </Tooltip>
                                </td>

                                <td
                                  style={{
                                    ...tdStyle,
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <Tooltip
                                    title={stripHtmlTags(
                                      change.current || change.new,
                                    )}
                                  >
                                    <span
                                      style={{
                                        ...getValueBadgeStyle(
                                          change.current || change.new,
                                          change.field ||
                                            change.changedProperty,
                                        ),
                                        maxWidth: 120,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        display: "inline-block",
                                        verticalAlign: "middle",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {stripHtmlTags(
                                        change.current || change.new,
                                      ) || "N/A"}
                                    </span>
                                  </Tooltip>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan={6}
                                style={{
                                  ...tdStyle,
                                  borderRight: "none",
                                  textAlign: "center",
                                  color: "#6b7280",
                                }}
                              >
                                No updates available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>

                {!isFollowUpNotification && (
                  <div
                    style={{
                      padding: "16px 18px",
                      background: "#f8fafc",
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 12,
                      borderBottomLeftRadius: 8,
                      borderBottomRightRadius: 8,
                    }}
                  >
                    <Button onClick={() => setModalVisible(false)}>Close</Button>

                    {navigateUrl && (
                      <Button
                        type="primary"
                        onClick={() => {
                          navigate(navigateUrl);
                          setModalVisible(false);
                        }}
                        style={{
                          background: "#0f1f35",
                          borderColor: "#0f1f35",
                          fontWeight: 600,
                        }}
                      >
                        {isTask ? "View Task →" : "View Lead →"}
                      </Button>
                    )}
                  </div>
                )}
              </>
            );
          })()}
      </Modal>
    </>
  );
};

export default Navbar;
